var items = {
  "block.minecraft.acacia_button": "Akakja tastanen",
  "block.minecraft.acacia_door": "Akakja dvera",
  "block.minecraft.acacia_fence": "Akakja vjetkatumam",
  "block.minecraft.acacia_fence_gate": "Akakja vjetkadvera",
  "block.minecraft.acacia_hanging_sign": "Akakja shankotumam",
  "block.minecraft.acacia_leaves": "Akakjalehti",
  "block.minecraft.acacia_log": "Akakjadjido",
  "block.minecraft.acacia_planks": "Akakja-baumtel",
  "block.minecraft.acacia_pressure_plate": "Akakja jalakatasta",
  "block.minecraft.acacia_sapling": "Akakja baumnen",
  "block.minecraft.acacia_shelf": "Akakja tumamstol",
  "block.minecraft.acacia_sign": "Akakja kotumam",
  "block.minecraft.acacia_slab": "Akakja handado",
  "block.minecraft.acacia_stairs": "Akakja leo",
  "block.minecraft.acacia_trapdoor": "Akakja jalakadvera",
  "block.minecraft.acacia_wall_hanging_sign": "Akakja spada-kotumam shang tumam",
  "block.minecraft.acacia_wall_sign": "Akakja kotumam per tumam",
  "block.minecraft.acacia_wood": "Akakjabaum",
  "block.minecraft.activator_rail": "Zeusøze-naruga",
  "block.minecraft.air": "Luft",
  "block.minecraft.allium": "Loklule",
  "block.minecraft.amethyst_block": "Murakacha dado",
  "block.minecraft.amethyst_cluster": "Murakacha petra",
  "block.minecraft.ancient_debris": "Protomyl",
  "block.minecraft.andesite": "Andesit",
  "block.minecraft.andesite_slab": "Handado na andesit",
  "block.minecraft.andesite_stairs": "Andesitleo",
  "block.minecraft.andesite_wall": "Andesittumam",
  "block.minecraft.anvil": "Bigorna",
  "block.minecraft.attached_melon_stem": "Tsunaga ishkefraut-djido",
  "block.minecraft.attached_pumpkin_stem": "Djido fu achorfraut tsunagjena",
  "block.minecraft.azalea": "Azalija",
  "block.minecraft.azalea_leaves": "Lehti fu azalija",
  "block.minecraft.azure_bluet": "Blaunen",
  "block.minecraft.bamboo": "Sembaum",
  "block.minecraft.bamboo_block": "Sembaumdado",
  "block.minecraft.bamboo_button": "Sembaum presmi",
  "block.minecraft.bamboo_door": "Sembaum dver",
  "block.minecraft.bamboo_fence": "Sembaum vjetkatumam",
  "block.minecraft.bamboo_fence_gate": "Sembaum vjetkadvera",
  "block.minecraft.bamboo_hanging_sign": "Sembaum shankotumam",
  "block.minecraft.bamboo_mosaic": "Breitena sembaum",
  "block.minecraft.bamboo_mosaic_slab": "Breitena sembaum na handado",
  "block.minecraft.bamboo_mosaic_stairs": "Breitena sembaum na leo",
  "block.minecraft.bamboo_planks": "Sembaumtel",
  "block.minecraft.bamboo_pressure_plate": "Sembaum jalakatasta",
  "block.minecraft.bamboo_sapling": "Sembaumnen",
  "block.minecraft.bamboo_shelf": "Sembaum apal",
  "block.minecraft.bamboo_sign": "Sembaum kotumam",
  "block.minecraft.bamboo_slab": "Sembaum handado",
  "block.minecraft.bamboo_stairs": "Sembaum leo",
  "block.minecraft.bamboo_trapdoor": "Sembaum jalakadver",
  "block.minecraft.bamboo_wall_hanging_sign": "Sembaum spada-kotumam shann tumam",
  "block.minecraft.bamboo_wall_sign": "Sembaum kotumam per tumam",
  "block.minecraft.banner.base.black": "Kuro pol",
  "block.minecraft.banner.base.blue": "Blau pol",
  "block.minecraft.banner.base.brown": "Kafe pol",
  "block.minecraft.banner.base.cyan": "Tsulus pol",
  "block.minecraft.banner.base.gray": "Gris pol",
  "block.minecraft.banner.base.green": "Midori pol",
  "block.minecraft.banner.base.light_blue": "Sini pol",
  "block.minecraft.banner.base.light_gray": "Shirogris pol",
  "block.minecraft.banner.base.lime": "Shiromidori pol",
  "block.minecraft.banner.base.magenta": "Romura pol",
  "block.minecraft.banner.base.orange": "Portokali pol",
  "block.minecraft.banner.base.pink": "Roza pol",
  "block.minecraft.banner.base.purple": "Muranen pol",
  "block.minecraft.banner.base.red": "Ro pol",
  "block.minecraft.banner.base.white": "Shiro pol",
  "block.minecraft.banner.base.yellow": "Kiiro pol",
  "block.minecraft.banner.border.black": "Kuro bideskrais",
  "block.minecraft.banner.border.blue": "Blau bideskrais",
  "block.minecraft.banner.border.brown": "Kafe bideskrais",
  "block.minecraft.banner.border.cyan": "Tsulus bideskrais",
  "block.minecraft.banner.border.gray": "Gris bideskrais",
  "block.minecraft.banner.border.green": "Midori bideskrais",
  "block.minecraft.banner.border.light_blue": "Sini bideskrais",
  "block.minecraft.banner.border.light_gray": "Shirogris bideskrais",
  "block.minecraft.banner.border.lime": "Shiromidori bideskrais",
  "block.minecraft.banner.border.magenta": "Romura bideskrais",
  "block.minecraft.banner.border.orange": "Portokali bideskrais",
  "block.minecraft.banner.border.pink": "Roza bideskrais",
  "block.minecraft.banner.border.purple": "Muranen bideskrais",
  "block.minecraft.banner.border.red": "Ro bideskrais",
  "block.minecraft.banner.border.white": "Shiro bideskrais",
  "block.minecraft.banner.border.yellow": "Kiiro bideskrais",
  "block.minecraft.banner.bricks.black": "Kuro hina gdent",
  "block.minecraft.banner.bricks.blue": "Blau hina gdent",
  "block.minecraft.banner.bricks.brown": "Brun hina gdent",
  "block.minecraft.banner.bricks.cyan": "Tsulus hina gdent",
  "block.minecraft.banner.bricks.gray": "Griz hina gdent",
  "block.minecraft.banner.bricks.green": "Midori hina gdent",
  "block.minecraft.banner.bricks.light_blue": "Sini hina gdent",
  "block.minecraft.banner.bricks.light_gray": "Shirogris hina gdent",
  "block.minecraft.banner.bricks.lime": "Zjelon hina gdent",
  "block.minecraft.banner.bricks.magenta": "Romura hina gdent",
  "block.minecraft.banner.bricks.orange": "Portokali hina gdent",
  "block.minecraft.banner.bricks.pink": "Roza hina gdent",
  "block.minecraft.banner.bricks.purple": "Muranen hina gdent",
  "block.minecraft.banner.bricks.red": "Ro hina gdent",
  "block.minecraft.banner.bricks.white": "Shiro hina gdent",
  "block.minecraft.banner.bricks.yellow": "Kiro hina gdent",
  "block.minecraft.banner.circle.black": "Kuro melankrais",
  "block.minecraft.banner.circle.blue": "Blau melankrais",
  "block.minecraft.banner.circle.brown": "Kafe melankrais",
  "block.minecraft.banner.circle.cyan": "Tsulus melankrais",
  "block.minecraft.banner.circle.gray": "Gris melankrais",
  "block.minecraft.banner.circle.green": "Midori melankrais",
  "block.minecraft.banner.circle.light_blue": "Sini melankrais",
  "block.minecraft.banner.circle.light_gray": "Shirogris melankrais",
  "block.minecraft.banner.circle.lime": "Shiromidori melankrais",
  "block.minecraft.banner.circle.magenta": "Romura melankrais",
  "block.minecraft.banner.circle.orange": "Portokali melankrais",
  "block.minecraft.banner.circle.pink": "Roza melankrais",
  "block.minecraft.banner.circle.purple": "Muranen melankrais",
  "block.minecraft.banner.circle.red": "Ro melankrais",
  "block.minecraft.banner.circle.white": "Shiro melankrais",
  "block.minecraft.banner.circle.yellow": "Kiiro melankrais",
  "block.minecraft.banner.creeper.black": "Kuro Creeper bumshtof",
  "block.minecraft.banner.creeper.blue": "Blau Creeper bumshtof",
  "block.minecraft.banner.creeper.brown": "Kafe Creeper bumshtof",
  "block.minecraft.banner.creeper.cyan": "Tsulus Creeper bumshtof",
  "block.minecraft.banner.creeper.gray": "Gris Creeper bumshtof",
  "block.minecraft.banner.creeper.green": "Midori Creeper bumshtof",
  "block.minecraft.banner.creeper.light_blue": "Sini Creeper bumshtof",
  "block.minecraft.banner.creeper.light_gray": "Shirogris Creeper bumshtof",
  "block.minecraft.banner.creeper.lime": "Shiromidori Creeper bumshtof",
  "block.minecraft.banner.creeper.magenta": "Romura Creeper bumshtof",
  "block.minecraft.banner.creeper.orange": "Portokali Creeper bumshtof",
  "block.minecraft.banner.creeper.pink": "Roza Creeper bumshtof",
  "block.minecraft.banner.creeper.purple": "Muranen Creeper bumshtof",
  "block.minecraft.banner.creeper.red": "Ro Creeper bumshtof",
  "block.minecraft.banner.creeper.white": "Shiro Creeper bumshtof",
  "block.minecraft.banner.creeper.yellow": "Kiiro Creeper bumshtof",
  "block.minecraft.banner.cross.black": "Kuro eksfal",
  "block.minecraft.banner.cross.blue": "Blau eksfal",
  "block.minecraft.banner.cross.brown": "Kafe eksfal",
  "block.minecraft.banner.cross.cyan": "Tsulus eksfal",
  "block.minecraft.banner.cross.gray": "Gris eksfal",
  "block.minecraft.banner.cross.green": "Midori eksfal",
  "block.minecraft.banner.cross.light_blue": "Sini eksfal",
  "block.minecraft.banner.cross.light_gray": "Shirogris eksfal",
  "block.minecraft.banner.cross.lime": "Shiromidori eksfal",
  "block.minecraft.banner.cross.magenta": "Romura eksfal",
  "block.minecraft.banner.cross.orange": "Portokali eksfal",
  "block.minecraft.banner.cross.pink": "Roza eksfal",
  "block.minecraft.banner.cross.purple": "Muranen eksfal",
  "block.minecraft.banner.cross.red": "Ro eksfal",
  "block.minecraft.banner.cross.white": "Shiro eksfal",
  "block.minecraft.banner.cross.yellow": "Kiiro eksfal",
  "block.minecraft.banner.curly_border.black": "Kuro bideskrais mitt hammas",
  "block.minecraft.banner.curly_border.blue": "Blau bideskrais mitt hammas",
  "block.minecraft.banner.curly_border.brown": "Kafe bideskrais mitt hammas",
  "block.minecraft.banner.curly_border.cyan": "Tsulus bideskrais mitt hammas",
  "block.minecraft.banner.curly_border.gray": "Gris bideskrais mitt hammas",
  "block.minecraft.banner.curly_border.green": "Midori bideskrais mitt hammas",
  "block.minecraft.banner.curly_border.light_blue": "Sini bideskrais mitt hammas",
  "block.minecraft.banner.curly_border.light_gray": "Shirogris bideskrais mitt hammas",
  "block.minecraft.banner.curly_border.lime": "Shiromidori bideskrais mitt hammas",
  "block.minecraft.banner.curly_border.magenta": "Romura bideskrais mitt hammas",
  "block.minecraft.banner.curly_border.orange": "Portokali bideskrais mitt hammas",
  "block.minecraft.banner.curly_border.pink": "Roza bideskrais mitt hammas",
  "block.minecraft.banner.curly_border.purple": "Muranen bideskrais mitt hammas",
  "block.minecraft.banner.curly_border.red": "Ro bideskrais mitt hammas",
  "block.minecraft.banner.curly_border.white": "Shiro bideskrais mitt hammas",
  "block.minecraft.banner.curly_border.yellow": "Kiiro bideskrais mitt hammas",
  "block.minecraft.banner.diagonal_left.black": "Kuro migioba treik",
  "block.minecraft.banner.diagonal_left.blue": "Blau migioba treik",
  "block.minecraft.banner.diagonal_left.brown": "Kafe migioba treik",
  "block.minecraft.banner.diagonal_left.cyan": "Tsulus migioba treik",
  "block.minecraft.banner.diagonal_left.gray": "Gris migioba treik",
  "block.minecraft.banner.diagonal_left.green": "Midori migioba treik",
  "block.minecraft.banner.diagonal_left.light_blue": "Sini migioba treik",
  "block.minecraft.banner.diagonal_left.light_gray": "Shirogris migioba treik",
  "block.minecraft.banner.diagonal_left.lime": "Shiromidori migioba treik",
  "block.minecraft.banner.diagonal_left.magenta": "Romura migioba treik",
  "block.minecraft.banner.diagonal_left.orange": "Portokali migioba treik",
  "block.minecraft.banner.diagonal_left.pink": "Roza migioba treik",
  "block.minecraft.banner.diagonal_left.purple": "Muranen migioba treik",
  "block.minecraft.banner.diagonal_left.red": "Ro migioba treik",
  "block.minecraft.banner.diagonal_left.white": "Shiro migioba treik",
  "block.minecraft.banner.diagonal_left.yellow": "Kiiro migioba treik",
  "block.minecraft.banner.diagonal_right.black": "Kuro ljevaoba treik",
  "block.minecraft.banner.diagonal_right.blue": "Blau ljevaoba treik",
  "block.minecraft.banner.diagonal_right.brown": "Kafe ljevaoba treik",
  "block.minecraft.banner.diagonal_right.cyan": "Tsulus ljevaoba treik",
  "block.minecraft.banner.diagonal_right.gray": "Gris ljevaoba treik",
  "block.minecraft.banner.diagonal_right.green": "Midori ljevaoba treik",
  "block.minecraft.banner.diagonal_right.light_blue": "Sini ljevaoba treik",
  "block.minecraft.banner.diagonal_right.light_gray": "Shirogris ljevaoba treik",
  "block.minecraft.banner.diagonal_right.lime": "Shiromidori ljevaoba treik",
  "block.minecraft.banner.diagonal_right.magenta": "Romura ljevaoba treik",
  "block.minecraft.banner.diagonal_right.orange": "Portokali ljevaoba treik",
  "block.minecraft.banner.diagonal_right.pink": "Roza ljevaoba treik",
  "block.minecraft.banner.diagonal_right.purple": "Muranen ljevaoba treik",
  "block.minecraft.banner.diagonal_right.red": "Ro ljevaoba treik",
  "block.minecraft.banner.diagonal_right.white": "Shiro ljevaoba treik",
  "block.minecraft.banner.diagonal_right.yellow": "Kiiro ljevaoba treik",
  "block.minecraft.banner.diagonal_up_left.black": "Kuro migiunna treik",
  "block.minecraft.banner.diagonal_up_left.blue": "Blau migiunna treik",
  "block.minecraft.banner.diagonal_up_left.brown": "Kafe migiunna treik",
  "block.minecraft.banner.diagonal_up_left.cyan": "Tsulus migiunna treik",
  "block.minecraft.banner.diagonal_up_left.gray": "Gris migiunna treik",
  "block.minecraft.banner.diagonal_up_left.green": "Midori migiunna treik",
  "block.minecraft.banner.diagonal_up_left.light_blue": "Sini migiunna treik",
  "block.minecraft.banner.diagonal_up_left.light_gray": "Shirogris migiunna treik",
  "block.minecraft.banner.diagonal_up_left.lime": "Shiromidori migiunna treik",
  "block.minecraft.banner.diagonal_up_left.magenta": "Romura migiunna treik",
  "block.minecraft.banner.diagonal_up_left.orange": "Portokali migiunna treik",
  "block.minecraft.banner.diagonal_up_left.pink": "Roza migiunna treik",
  "block.minecraft.banner.diagonal_up_left.purple": "Muranen migiunna treik",
  "block.minecraft.banner.diagonal_up_left.red": "Ro migiunna treik",
  "block.minecraft.banner.diagonal_up_left.white": "Shiro migiunna treik",
  "block.minecraft.banner.diagonal_up_left.yellow": "Kiiro migiunna treik",
  "block.minecraft.banner.diagonal_up_right.black": "Kuro ljevaunna treik",
  "block.minecraft.banner.diagonal_up_right.blue": "Blau ljevaunna treik",
  "block.minecraft.banner.diagonal_up_right.brown": "Kafe ljevaunna treik",
  "block.minecraft.banner.diagonal_up_right.cyan": "Tsulus ljevaunna treik",
  "block.minecraft.banner.diagonal_up_right.gray": "Gris ljevaunna treik",
  "block.minecraft.banner.diagonal_up_right.green": "Midori ljevaunna treik",
  "block.minecraft.banner.diagonal_up_right.light_blue": "Sini ljevaunna treik",
  "block.minecraft.banner.diagonal_up_right.light_gray": "Shirogris ljevaunna treik",
  "block.minecraft.banner.diagonal_up_right.lime": "Shiromidori ljevaunna treik",
  "block.minecraft.banner.diagonal_up_right.magenta": "Romura ljevaunna treik",
  "block.minecraft.banner.diagonal_up_right.orange": "Portokali ljevaunna treik",
  "block.minecraft.banner.diagonal_up_right.pink": "Roza ljevaunna treik",
  "block.minecraft.banner.diagonal_up_right.purple": "Muranen ljevaunna treik",
  "block.minecraft.banner.diagonal_up_right.red": "Ro ljevaunna treik",
  "block.minecraft.banner.diagonal_up_right.white": "Shiro ljevaunna treik",
  "block.minecraft.banner.diagonal_up_right.yellow": "Kiiro ljevaunna treik",
  "block.minecraft.banner.flow.black": "Kuro virta",
  "block.minecraft.banner.flow.blue": "Blau virta",
  "block.minecraft.banner.flow.brown": "Kafe virta",
  "block.minecraft.banner.flow.cyan": "Tsulus virta",
  "block.minecraft.banner.flow.gray": "Gris virta",
  "block.minecraft.banner.flow.green": "Midori virta",
  "block.minecraft.banner.flow.light_blue": "Sini virta",
  "block.minecraft.banner.flow.light_gray": "Shirogris virta",
  "block.minecraft.banner.flow.lime": "Zjelon virta",
  "block.minecraft.banner.flow.magenta": "Romura virta",
  "block.minecraft.banner.flow.orange": "Portokali virta",
  "block.minecraft.banner.flow.pink": "Roza virta",
  "block.minecraft.banner.flow.purple": "Muranen virta",
  "block.minecraft.banner.flow.red": "Ros virta",
  "block.minecraft.banner.flow.white": "Shiro virta",
  "block.minecraft.banner.flow.yellow": "Kiiro virta",
  "block.minecraft.banner.flower.black": "Kuro lule bumshtof",
  "block.minecraft.banner.flower.blue": "Blau lule bumshtof",
  "block.minecraft.banner.flower.brown": "Kafe lule bumshtof",
  "block.minecraft.banner.flower.cyan": "Tsulus lule bumshtof",
  "block.minecraft.banner.flower.gray": "Gris lule bumshtof",
  "block.minecraft.banner.flower.green": "Midori lule bumshtof",
  "block.minecraft.banner.flower.light_blue": "Sini lule bumshtof",
  "block.minecraft.banner.flower.light_gray": "Shirogris lule bumshtof",
  "block.minecraft.banner.flower.lime": "Shiromidori lule bumshtof",
  "block.minecraft.banner.flower.magenta": "Romura lule bumshtof",
  "block.minecraft.banner.flower.orange": "Portokali lule bumshtof",
  "block.minecraft.banner.flower.pink": "Roza lule bumshtof",
  "block.minecraft.banner.flower.purple": "Muranen lule bumshtof",
  "block.minecraft.banner.flower.red": "Ro lule bumshtof",
  "block.minecraft.banner.flower.white": "Shiro lule bumshtof",
  "block.minecraft.banner.flower.yellow": "Kiiro lule bumshtof",
  "block.minecraft.banner.globe.black": "Kuro veltmjah",
  "block.minecraft.banner.globe.blue": "Blau veltmjah",
  "block.minecraft.banner.globe.brown": "Kafe veltmjah",
  "block.minecraft.banner.globe.cyan": "Tsulus veltmjah",
  "block.minecraft.banner.globe.gray": "Gris veltmjah",
  "block.minecraft.banner.globe.green": "Midori veltmjah",
  "block.minecraft.banner.globe.light_blue": "Sini veltmjah",
  "block.minecraft.banner.globe.light_gray": "Shirogris veltmjah",
  "block.minecraft.banner.globe.lime": "Shiromidori veltmjah",
  "block.minecraft.banner.globe.magenta": "Romura veltmjah",
  "block.minecraft.banner.globe.orange": "Portokali veltmjah",
  "block.minecraft.banner.globe.pink": "Roza veltmjah",
  "block.minecraft.banner.globe.purple": "Muranen veltmjah",
  "block.minecraft.banner.globe.red": "Ro veltmjah",
  "block.minecraft.banner.globe.white": "Shiro veltmjah",
  "block.minecraft.banner.globe.yellow": "Kiiro veltmjah",
  "block.minecraft.banner.gradient.black": "Kuro obavisk",
  "block.minecraft.banner.gradient.blue": "Blau obavisk",
  "block.minecraft.banner.gradient.brown": "Kafe obavisk",
  "block.minecraft.banner.gradient.cyan": "Tsulus obavisk",
  "block.minecraft.banner.gradient.gray": "Gris obavisk",
  "block.minecraft.banner.gradient.green": "Midori obavisk",
  "block.minecraft.banner.gradient.light_blue": "Sini obavisk",
  "block.minecraft.banner.gradient.light_gray": "Shirogris obavisk",
  "block.minecraft.banner.gradient.lime": "Shiromidori obavisk",
  "block.minecraft.banner.gradient.magenta": "Romura obavisk",
  "block.minecraft.banner.gradient.orange": "Portokali obavisk",
  "block.minecraft.banner.gradient.pink": "Roza obavisk",
  "block.minecraft.banner.gradient.purple": "Muranen obavisk",
  "block.minecraft.banner.gradient.red": "Ro obavisk",
  "block.minecraft.banner.gradient.white": "Shiro obavisk",
  "block.minecraft.banner.gradient.yellow": "Kiiro obavisk",
  "block.minecraft.banner.gradient_up.black": "Kuro unnavisk",
  "block.minecraft.banner.gradient_up.blue": "Blau unnavisk",
  "block.minecraft.banner.gradient_up.brown": "Kafe unnavisk",
  "block.minecraft.banner.gradient_up.cyan": "Tsulus unnavisk",
  "block.minecraft.banner.gradient_up.gray": "Gris unnavisk",
  "block.minecraft.banner.gradient_up.green": "Midori unnavisk",
  "block.minecraft.banner.gradient_up.light_blue": "Sini unnavisk",
  "block.minecraft.banner.gradient_up.light_gray": "Shirogris unnavisk",
  "block.minecraft.banner.gradient_up.lime": "Shiromidori unnavisk",
  "block.minecraft.banner.gradient_up.magenta": "Romura unnavisk",
  "block.minecraft.banner.gradient_up.orange": "Portokali unnavisk",
  "block.minecraft.banner.gradient_up.pink": "Roza unnavisk",
  "block.minecraft.banner.gradient_up.purple": "Muranen unnavisk",
  "block.minecraft.banner.gradient_up.red": "Ro unnavisk",
  "block.minecraft.banner.gradient_up.white": "Shiro unnavisk",
  "block.minecraft.banner.gradient_up.yellow": "Kiiro unnavisk",
  "block.minecraft.banner.guster.black": "Kuro luftnen",
  "block.minecraft.banner.guster.blue": "Blau luftnen",
  "block.minecraft.banner.guster.brown": "Brun luftnen",
  "block.minecraft.banner.guster.cyan": "Cjan luftnen",
  "block.minecraft.banner.guster.gray": "Gris luftnen",
  "block.minecraft.banner.guster.green": "Midori luftnen",
  "block.minecraft.banner.guster.light_blue": "Sini luftnen",
  "block.minecraft.banner.guster.light_gray": "Shirogris luftnen",
  "block.minecraft.banner.guster.lime": "Shiromidori luftnen",
  "block.minecraft.banner.guster.magenta": "Romura luftnen",
  "block.minecraft.banner.guster.orange": "Portokali luftnen",
  "block.minecraft.banner.guster.pink": "Roza luftnen",
  "block.minecraft.banner.guster.purple": "Murasaki luftnen",
  "block.minecraft.banner.guster.red": "Ros luftnen",
  "block.minecraft.banner.guster.white": "Shiro luftnen",
  "block.minecraft.banner.guster.yellow": "Kiro luftnen",
  "block.minecraft.banner.half_horizontal.black": "Kuro obatel",
  "block.minecraft.banner.half_horizontal.blue": "Blau obatel",
  "block.minecraft.banner.half_horizontal.brown": "Kafe obatel",
  "block.minecraft.banner.half_horizontal.cyan": "Tsulus obatel",
  "block.minecraft.banner.half_horizontal.gray": "Gris obatel",
  "block.minecraft.banner.half_horizontal.green": "Midori obatel",
  "block.minecraft.banner.half_horizontal.light_blue": "Sini obatel",
  "block.minecraft.banner.half_horizontal.light_gray": "Shirogris obatel",
  "block.minecraft.banner.half_horizontal.lime": "Shiromidori obatel",
  "block.minecraft.banner.half_horizontal.magenta": "Romura obatel",
  "block.minecraft.banner.half_horizontal.orange": "Portokali obatel",
  "block.minecraft.banner.half_horizontal.pink": "Roza obatel",
  "block.minecraft.banner.half_horizontal.purple": "Muranen obatel",
  "block.minecraft.banner.half_horizontal.red": "Ro obatel",
  "block.minecraft.banner.half_horizontal.white": "Shiro obatel",
  "block.minecraft.banner.half_horizontal.yellow": "Kiiro obatel",
  "block.minecraft.banner.half_horizontal_bottom.black": "Kuro unnatel",
  "block.minecraft.banner.half_horizontal_bottom.blue": "Blau unnatel",
  "block.minecraft.banner.half_horizontal_bottom.brown": "Kafe unnatel",
  "block.minecraft.banner.half_horizontal_bottom.cyan": "Tsulus unnatel",
  "block.minecraft.banner.half_horizontal_bottom.gray": "Gris unnatel",
  "block.minecraft.banner.half_horizontal_bottom.green": "Midori unnatel",
  "block.minecraft.banner.half_horizontal_bottom.light_blue": "Sini unnatel",
  "block.minecraft.banner.half_horizontal_bottom.light_gray": "Shirogris unnatel",
  "block.minecraft.banner.half_horizontal_bottom.lime": "Shiromidori unnatel",
  "block.minecraft.banner.half_horizontal_bottom.magenta": "Romura unnatel",
  "block.minecraft.banner.half_horizontal_bottom.orange": "Portokali unnatel",
  "block.minecraft.banner.half_horizontal_bottom.pink": "Roza unnatel",
  "block.minecraft.banner.half_horizontal_bottom.purple": "Muranen unnatel",
  "block.minecraft.banner.half_horizontal_bottom.red": "Ro unnatel",
  "block.minecraft.banner.half_horizontal_bottom.white": "Shiro unnatel",
  "block.minecraft.banner.half_horizontal_bottom.yellow": "Kiiro unnatel",
  "block.minecraft.banner.half_vertical.black": "Kuro ljevatel",
  "block.minecraft.banner.half_vertical.blue": "Blau ljevatel",
  "block.minecraft.banner.half_vertical.brown": "Kafe ljevatel",
  "block.minecraft.banner.half_vertical.cyan": "Tsulus ljevatel",
  "block.minecraft.banner.half_vertical.gray": "Gris ljevatel",
  "block.minecraft.banner.half_vertical.green": "Midori ljevatel",
  "block.minecraft.banner.half_vertical.light_blue": "Sini ljevatel",
  "block.minecraft.banner.half_vertical.light_gray": "Shirogris ljevatel",
  "block.minecraft.banner.half_vertical.lime": "Shiromidori ljevatel",
  "block.minecraft.banner.half_vertical.magenta": "Romura ljevatel",
  "block.minecraft.banner.half_vertical.orange": "Portokali ljevatel",
  "block.minecraft.banner.half_vertical.pink": "Roza ljevatel",
  "block.minecraft.banner.half_vertical.purple": "Muranen ljevatel",
  "block.minecraft.banner.half_vertical.red": "Ro ljevatel",
  "block.minecraft.banner.half_vertical.white": "Shiro ljevatel",
  "block.minecraft.banner.half_vertical.yellow": "Kiiro ljevatel",
  "block.minecraft.banner.half_vertical_right.black": "Kuro migitel",
  "block.minecraft.banner.half_vertical_right.blue": "Blau migitel",
  "block.minecraft.banner.half_vertical_right.brown": "Kafe migitel",
  "block.minecraft.banner.half_vertical_right.cyan": "Tsulus migitel",
  "block.minecraft.banner.half_vertical_right.gray": "Gris migitel",
  "block.minecraft.banner.half_vertical_right.green": "Midori migitel",
  "block.minecraft.banner.half_vertical_right.light_blue": "Sini migitel",
  "block.minecraft.banner.half_vertical_right.light_gray": "Shirogris migitel",
  "block.minecraft.banner.half_vertical_right.lime": "Shiromidori migitel",
  "block.minecraft.banner.half_vertical_right.magenta": "Romura migitel",
  "block.minecraft.banner.half_vertical_right.orange": "Portokali migitel",
  "block.minecraft.banner.half_vertical_right.pink": "Roza migitel",
  "block.minecraft.banner.half_vertical_right.purple": "Muranen migitel",
  "block.minecraft.banner.half_vertical_right.red": "Ro migitel",
  "block.minecraft.banner.half_vertical_right.white": "Shiro migitel",
  "block.minecraft.banner.half_vertical_right.yellow": "Kiiro migitel",
  "block.minecraft.banner.mojang.black": "Kuro ting",
  "block.minecraft.banner.mojang.blue": "Blau Ting",
  "block.minecraft.banner.mojang.brown": "Kafe Ting",
  "block.minecraft.banner.mojang.cyan": "Tsulus Ting",
  "block.minecraft.banner.mojang.gray": "Gris Ting",
  "block.minecraft.banner.mojang.green": "Midori Ting",
  "block.minecraft.banner.mojang.light_blue": "Sini Ting",
  "block.minecraft.banner.mojang.light_gray": "Shirogris Ting",
  "block.minecraft.banner.mojang.lime": "Shiromidori Ting",
  "block.minecraft.banner.mojang.magenta": "Romura Ting",
  "block.minecraft.banner.mojang.orange": "Portokali Ting",
  "block.minecraft.banner.mojang.pink": "Roza Ting",
  "block.minecraft.banner.mojang.purple": "Muranen Ting",
  "block.minecraft.banner.mojang.red": "Ro Ting",
  "block.minecraft.banner.mojang.white": "Shiro Ting",
  "block.minecraft.banner.mojang.yellow": "Kiiro Ting",
  "block.minecraft.banner.piglin.black": "Kuro hana",
  "block.minecraft.banner.piglin.blue": "Blau hana",
  "block.minecraft.banner.piglin.brown": "Kafe hana",
  "block.minecraft.banner.piglin.cyan": "Tsulus hana",
  "block.minecraft.banner.piglin.gray": "Gris hana",
  "block.minecraft.banner.piglin.green": "Midori hana",
  "block.minecraft.banner.piglin.light_blue": "Sini hana",
  "block.minecraft.banner.piglin.light_gray": "Shirogris hana",
  "block.minecraft.banner.piglin.lime": "Shiromidori hana",
  "block.minecraft.banner.piglin.magenta": "Romura hana",
  "block.minecraft.banner.piglin.orange": "Portokali hana",
  "block.minecraft.banner.piglin.pink": "Roza hana",
  "block.minecraft.banner.piglin.purple": "Muranen hana",
  "block.minecraft.banner.piglin.red": "Ro hana",
  "block.minecraft.banner.piglin.white": "Shiro hana",
  "block.minecraft.banner.piglin.yellow": "Kiiro hana",
  "block.minecraft.banner.rhombus.black": "Kuro melankereik",
  "block.minecraft.banner.rhombus.blue": "Blau melankereik",
  "block.minecraft.banner.rhombus.brown": "Kafe melankereik",
  "block.minecraft.banner.rhombus.cyan": "Tsulus melankereik",
  "block.minecraft.banner.rhombus.gray": "Gris melankereik",
  "block.minecraft.banner.rhombus.green": "Midori melankereik",
  "block.minecraft.banner.rhombus.light_blue": "Sini melankereik",
  "block.minecraft.banner.rhombus.light_gray": "Shirogris melankereik",
  "block.minecraft.banner.rhombus.lime": "Shiromidori melankereik",
  "block.minecraft.banner.rhombus.magenta": "Romura melankereik",
  "block.minecraft.banner.rhombus.orange": "Portokali melankereik",
  "block.minecraft.banner.rhombus.pink": "Roza melankereik",
  "block.minecraft.banner.rhombus.purple": "Muranen melankereik",
  "block.minecraft.banner.rhombus.red": "Ro lepamedai",
  "block.minecraft.banner.rhombus.white": "Shiro melankereik",
  "block.minecraft.banner.rhombus.yellow": "Kiiro melankereik",
  "block.minecraft.banner.skull.black": "Kuro poneatama bumshtof",
  "block.minecraft.banner.skull.blue": "Blau poneatama bumshtof",
  "block.minecraft.banner.skull.brown": "Kafe poneatama bumshtof",
  "block.minecraft.banner.skull.cyan": "Tsulus poneatama bumshtof",
  "block.minecraft.banner.skull.gray": "Gris poneatama bumshtof",
  "block.minecraft.banner.skull.green": "Midori poneatama bumshtof",
  "block.minecraft.banner.skull.light_blue": "Sini poneatama bumshtof",
  "block.minecraft.banner.skull.light_gray": "Shirogris poneatama bumshtof",
  "block.minecraft.banner.skull.lime": "Shiromidori poneatama bumshtof",
  "block.minecraft.banner.skull.magenta": "Romura poneatama bumshtof",
  "block.minecraft.banner.skull.orange": "Portokali poneatama bumshtof",
  "block.minecraft.banner.skull.pink": "Roza poneatama bumshtof",
  "block.minecraft.banner.skull.purple": "Muranen poneatama bumshtof",
  "block.minecraft.banner.skull.red": "Ro poneatama bumshtof",
  "block.minecraft.banner.skull.white": "Shiro poneatama bumshtof",
  "block.minecraft.banner.skull.yellow": "Kiiro poneatama bumshtof",
  "block.minecraft.banner.small_stripes.black": "Kuro unnaoba sensen",
  "block.minecraft.banner.small_stripes.blue": "Blau unnaoba sensen",
  "block.minecraft.banner.small_stripes.brown": "Kafe unnaoba sensen",
  "block.minecraft.banner.small_stripes.cyan": "Tsulus unnaoba sensen",
  "block.minecraft.banner.small_stripes.gray": "Gris unnaoba sensen",
  "block.minecraft.banner.small_stripes.green": "Midori unnaoba sensen",
  "block.minecraft.banner.small_stripes.light_blue": "Sini unnaoba sensen",
  "block.minecraft.banner.small_stripes.light_gray": "Shirogris unnaoba sensen",
  "block.minecraft.banner.small_stripes.lime": "Shiromidori unnaoba sensen",
  "block.minecraft.banner.small_stripes.magenta": "Romura unnaoba sensen",
  "block.minecraft.banner.small_stripes.orange": "Portokali unnaoba sensen",
  "block.minecraft.banner.small_stripes.pink": "Roza unnaoba sensen",
  "block.minecraft.banner.small_stripes.purple": "Muranen unnaoba sensen",
  "block.minecraft.banner.small_stripes.red": "Ro unnaoba sensen",
  "block.minecraft.banner.small_stripes.white": "Shiro unnaoba sensen",
  "block.minecraft.banner.small_stripes.yellow": "Kiiro unnaoba sensen",
  "block.minecraft.banner.square_bottom_left.black": "Kuro ljevaunna",
  "block.minecraft.banner.square_bottom_left.blue": "Blau ljevaunna",
  "block.minecraft.banner.square_bottom_left.brown": "Kafe ljevaunna",
  "block.minecraft.banner.square_bottom_left.cyan": "Tsulus ljevaunna",
  "block.minecraft.banner.square_bottom_left.gray": "Gris ljevaunna",
  "block.minecraft.banner.square_bottom_left.green": "Midori ljevaunna",
  "block.minecraft.banner.square_bottom_left.light_blue": "Sini ljevaunna",
  "block.minecraft.banner.square_bottom_left.light_gray": "Shirogris ljevaunna",
  "block.minecraft.banner.square_bottom_left.lime": "Shiromidori ljevaunna",
  "block.minecraft.banner.square_bottom_left.magenta": "Romura ljevaunna",
  "block.minecraft.banner.square_bottom_left.orange": "Portokali ljevaunna",
  "block.minecraft.banner.square_bottom_left.pink": "Roza ljevaunna",
  "block.minecraft.banner.square_bottom_left.purple": "Muranen ljevaunna",
  "block.minecraft.banner.square_bottom_left.red": "Ro ljevaunna",
  "block.minecraft.banner.square_bottom_left.white": "Shiro ljevaunna",
  "block.minecraft.banner.square_bottom_left.yellow": "Kiiro ljevaunna",
  "block.minecraft.banner.square_bottom_right.black": "Kuro migiunna",
  "block.minecraft.banner.square_bottom_right.blue": "Blau migiunna",
  "block.minecraft.banner.square_bottom_right.brown": "Kafe migiunna",
  "block.minecraft.banner.square_bottom_right.cyan": "Tsulus migiunna",
  "block.minecraft.banner.square_bottom_right.gray": "Gris migiunna",
  "block.minecraft.banner.square_bottom_right.green": "Midori migiunna",
  "block.minecraft.banner.square_bottom_right.light_blue": "Sini migiunna",
  "block.minecraft.banner.square_bottom_right.light_gray": "Shirogris migiunna",
  "block.minecraft.banner.square_bottom_right.lime": "Shiromidori migiunna",
  "block.minecraft.banner.square_bottom_right.magenta": "Romura migiunna",
  "block.minecraft.banner.square_bottom_right.orange": "Portokali migiunna",
  "block.minecraft.banner.square_bottom_right.pink": "Roza migiunna",
  "block.minecraft.banner.square_bottom_right.purple": "Muranen migiunna",
  "block.minecraft.banner.square_bottom_right.red": "Ro migiunna",
  "block.minecraft.banner.square_bottom_right.white": "Shiro migiunna",
  "block.minecraft.banner.square_bottom_right.yellow": "Kiiro migiunna",
  "block.minecraft.banner.square_top_left.black": "Kuro ljevaoba",
  "block.minecraft.banner.square_top_left.blue": "Blau ljevaoba",
  "block.minecraft.banner.square_top_left.brown": "Kafe ljevaoba",
  "block.minecraft.banner.square_top_left.cyan": "Tsulus ljevaoba",
  "block.minecraft.banner.square_top_left.gray": "Gris ljevaoba",
  "block.minecraft.banner.square_top_left.green": "Midori ljevaoba",
  "block.minecraft.banner.square_top_left.light_blue": "Sini ljevaoba",
  "block.minecraft.banner.square_top_left.light_gray": "Shirogris ljevaoba",
  "block.minecraft.banner.square_top_left.lime": "Shiromidori ljevaoba",
  "block.minecraft.banner.square_top_left.magenta": "Romura ljevaoba",
  "block.minecraft.banner.square_top_left.orange": "Portokali ljevaoba",
  "block.minecraft.banner.square_top_left.pink": "Roza ljevaoba",
  "block.minecraft.banner.square_top_left.purple": "Muranen ljevaoba",
  "block.minecraft.banner.square_top_left.red": "Ro ljevaoba",
  "block.minecraft.banner.square_top_left.white": "Shiro ljevaoba",
  "block.minecraft.banner.square_top_left.yellow": "Kiiro ljevaoba",
  "block.minecraft.banner.square_top_right.black": "Kuro migioba",
  "block.minecraft.banner.square_top_right.blue": "Blau migioba",
  "block.minecraft.banner.square_top_right.brown": "Kafe migioba",
  "block.minecraft.banner.square_top_right.cyan": "Tsulus migioba",
  "block.minecraft.banner.square_top_right.gray": "Gris migioba",
  "block.minecraft.banner.square_top_right.green": "Midori migioba",
  "block.minecraft.banner.square_top_right.light_blue": "Sini migioba",
  "block.minecraft.banner.square_top_right.light_gray": "Shirogris migioba",
  "block.minecraft.banner.square_top_right.lime": "Shiromidori migioba",
  "block.minecraft.banner.square_top_right.magenta": "Romura migioba",
  "block.minecraft.banner.square_top_right.orange": "Portokali migioba",
  "block.minecraft.banner.square_top_right.pink": "Roza migioba",
  "block.minecraft.banner.square_top_right.purple": "Muranen migioba",
  "block.minecraft.banner.square_top_right.red": "Ro migioba",
  "block.minecraft.banner.square_top_right.white": "Shiro migioba",
  "block.minecraft.banner.square_top_right.yellow": "Kiiro migioba",
  "block.minecraft.banner.straight_cross.black": "Kuro plusfal",
  "block.minecraft.banner.straight_cross.blue": "Blau plusfal",
  "block.minecraft.banner.straight_cross.brown": "Kafe plusfal",
  "block.minecraft.banner.straight_cross.cyan": "Tsulus plusfal",
  "block.minecraft.banner.straight_cross.gray": "Gris plusfal",
  "block.minecraft.banner.straight_cross.green": "Midori plusfal",
  "block.minecraft.banner.straight_cross.light_blue": "Sini plusfal",
  "block.minecraft.banner.straight_cross.light_gray": "Shirogris plusfal",
  "block.minecraft.banner.straight_cross.lime": "Shiromidori plusfal",
  "block.minecraft.banner.straight_cross.magenta": "Romura plusfal",
  "block.minecraft.banner.straight_cross.orange": "Portokali plusfal",
  "block.minecraft.banner.straight_cross.pink": "Roza plusfal",
  "block.minecraft.banner.straight_cross.purple": "Muranen plusfal",
  "block.minecraft.banner.straight_cross.red": "Ro plusfal",
  "block.minecraft.banner.straight_cross.white": "Shiro plusfal",
  "block.minecraft.banner.straight_cross.yellow": "Kiiro plusfal",
  "block.minecraft.banner.stripe_bottom.black": "Kuro unnatretel",
  "block.minecraft.banner.stripe_bottom.blue": "Blau unnatretel",
  "block.minecraft.banner.stripe_bottom.brown": "Kafe unnatretel",
  "block.minecraft.banner.stripe_bottom.cyan": "Tsulus unnatretel",
  "block.minecraft.banner.stripe_bottom.gray": "Gris unnatretel",
  "block.minecraft.banner.stripe_bottom.green": "Midori unnatretel",
  "block.minecraft.banner.stripe_bottom.light_blue": "Sini unnatretel",
  "block.minecraft.banner.stripe_bottom.light_gray": "Shirogris unnatretel",
  "block.minecraft.banner.stripe_bottom.lime": "Shiromidori unnatretel",
  "block.minecraft.banner.stripe_bottom.magenta": "Romura unnatretel",
  "block.minecraft.banner.stripe_bottom.orange": "Portokali unnatretel",
  "block.minecraft.banner.stripe_bottom.pink": "Roza unnatretel",
  "block.minecraft.banner.stripe_bottom.purple": "Muranen unnatretel",
  "block.minecraft.banner.stripe_bottom.red": "Ro unnatretel",
  "block.minecraft.banner.stripe_bottom.white": "Shiro unnatretel",
  "block.minecraft.banner.stripe_bottom.yellow": "Kiiro unnatretel",
  "block.minecraft.banner.stripe_center.black": "Kuro unnaoba",
  "block.minecraft.banner.stripe_center.blue": "Blau unnaoba",
  "block.minecraft.banner.stripe_center.brown": "Kafe unnaoba",
  "block.minecraft.banner.stripe_center.cyan": "Tsulus unnaoba",
  "block.minecraft.banner.stripe_center.gray": "Gris unnaoba",
  "block.minecraft.banner.stripe_center.green": "Midori unnaoba",
  "block.minecraft.banner.stripe_center.light_blue": "Sini unnaoba",
  "block.minecraft.banner.stripe_center.light_gray": "Shirogris unnaoba",
  "block.minecraft.banner.stripe_center.lime": "Shiromidori unnaoba",
  "block.minecraft.banner.stripe_center.magenta": "Romura unnaoba",
  "block.minecraft.banner.stripe_center.orange": "Portokali unnaoba",
  "block.minecraft.banner.stripe_center.pink": "Roza unnaoba",
  "block.minecraft.banner.stripe_center.purple": "Muranen unnaoba",
  "block.minecraft.banner.stripe_center.red": "Ro unnaoba",
  "block.minecraft.banner.stripe_center.white": "Shiro unnaoba",
  "block.minecraft.banner.stripe_center.yellow": "Kiiro unnaoba",
  "block.minecraft.banner.stripe_downleft.black": "Kuro migiljevastrela",
  "block.minecraft.banner.stripe_downleft.blue": "Blau migiljevastrela",
  "block.minecraft.banner.stripe_downleft.brown": "Kafe migiljevastrela",
  "block.minecraft.banner.stripe_downleft.cyan": "Tsulus migiljevastrela",
  "block.minecraft.banner.stripe_downleft.gray": "Gris migiljevastrela",
  "block.minecraft.banner.stripe_downleft.green": "Midori migiljevastrela",
  "block.minecraft.banner.stripe_downleft.light_blue": "Sini migiljevastrela",
  "block.minecraft.banner.stripe_downleft.light_gray": "Shirogris migiljevastrela",
  "block.minecraft.banner.stripe_downleft.lime": "Shiromidori migiljevastrela",
  "block.minecraft.banner.stripe_downleft.magenta": "Romura migiljevastrela",
  "block.minecraft.banner.stripe_downleft.orange": "Portokali migiljevastrela",
  "block.minecraft.banner.stripe_downleft.pink": "Roza migiljevastrela",
  "block.minecraft.banner.stripe_downleft.purple": "Muranen migiljevastrela",
  "block.minecraft.banner.stripe_downleft.red": "Ro migiljevastrela",
  "block.minecraft.banner.stripe_downleft.white": "Shiro migiljevastrela",
  "block.minecraft.banner.stripe_downleft.yellow": "Kiiro migiljevastrela",
  "block.minecraft.banner.stripe_downright.black": "Kuro ljevamigistrela",
  "block.minecraft.banner.stripe_downright.blue": "Blau ljevamigistrela",
  "block.minecraft.banner.stripe_downright.brown": "Kafe ljevamigistrela",
  "block.minecraft.banner.stripe_downright.cyan": "Tsulus ljevamigistrela",
  "block.minecraft.banner.stripe_downright.gray": "Gris ljevamigistrela",
  "block.minecraft.banner.stripe_downright.green": "Midori ljevamigistrela",
  "block.minecraft.banner.stripe_downright.light_blue": "Sini ljevamigistrela",
  "block.minecraft.banner.stripe_downright.light_gray": "Shirogris ljevamigistrela",
  "block.minecraft.banner.stripe_downright.lime": "Shiromidori ljevamigistrela",
  "block.minecraft.banner.stripe_downright.magenta": "Romura ljevamigistrela",
  "block.minecraft.banner.stripe_downright.orange": "Portokali ljevamigistrela",
  "block.minecraft.banner.stripe_downright.pink": "Roza ljevamigistrela",
  "block.minecraft.banner.stripe_downright.purple": "Muranen ljevamigistrela",
  "block.minecraft.banner.stripe_downright.red": "Ro ljevamigistrela",
  "block.minecraft.banner.stripe_downright.white": "Shiro ljevamigistrela",
  "block.minecraft.banner.stripe_downright.yellow": "Kiiro ljevamigistrela",
  "block.minecraft.banner.stripe_left.black": "Kuro ljevatretel",
  "block.minecraft.banner.stripe_left.blue": "Blau ljevatretel",
  "block.minecraft.banner.stripe_left.brown": "Kafe ljevatretel",
  "block.minecraft.banner.stripe_left.cyan": "Tsulus ljevatretel",
  "block.minecraft.banner.stripe_left.gray": "Gris ljevatretel",
  "block.minecraft.banner.stripe_left.green": "Midori ljevatretel",
  "block.minecraft.banner.stripe_left.light_blue": "Sini ljevatretel",
  "block.minecraft.banner.stripe_left.light_gray": "Shirogris ljevatretel",
  "block.minecraft.banner.stripe_left.lime": "Shiromidori ljevatretel",
  "block.minecraft.banner.stripe_left.magenta": "Romura ljevatretel",
  "block.minecraft.banner.stripe_left.orange": "Portokali ljevatretel",
  "block.minecraft.banner.stripe_left.pink": "Roza ljevatretel",
  "block.minecraft.banner.stripe_left.purple": "Muranen ljevatretel",
  "block.minecraft.banner.stripe_left.red": "Ro ljevatretel",
  "block.minecraft.banner.stripe_left.white": "Shiro ljevatretel",
  "block.minecraft.banner.stripe_left.yellow": "Kiiro ljevatretel",
  "block.minecraft.banner.stripe_middle.black": "Kuro ljevamigisen",
  "block.minecraft.banner.stripe_middle.blue": "Blau ljevamigisen",
  "block.minecraft.banner.stripe_middle.brown": "Kafe ljevamigisen",
  "block.minecraft.banner.stripe_middle.cyan": "Tsulus ljevamigisen",
  "block.minecraft.banner.stripe_middle.gray": "Gris ljevamigisen",
  "block.minecraft.banner.stripe_middle.green": "Midori ljevamigisen",
  "block.minecraft.banner.stripe_middle.light_blue": "Sini ljevamigisen",
  "block.minecraft.banner.stripe_middle.light_gray": "Shirogris ljevamigisen",
  "block.minecraft.banner.stripe_middle.lime": "Shiromidori ljevamigisen",
  "block.minecraft.banner.stripe_middle.magenta": "Romura ljevamigisen",
  "block.minecraft.banner.stripe_middle.orange": "Portokali ljevamigisen",
  "block.minecraft.banner.stripe_middle.pink": "Roza ljevamigisen",
  "block.minecraft.banner.stripe_middle.purple": "Muranen ljevamigisen",
  "block.minecraft.banner.stripe_middle.red": "Ro ljevamigisen",
  "block.minecraft.banner.stripe_middle.white": "Shiro ljevamigisen",
  "block.minecraft.banner.stripe_middle.yellow": "Kiiro ljevamigisen",
  "block.minecraft.banner.stripe_right.black": "Kuro migiteltel",
  "block.minecraft.banner.stripe_right.blue": "Blau migiteltel",
  "block.minecraft.banner.stripe_right.brown": "Kafe migiteltel",
  "block.minecraft.banner.stripe_right.cyan": "Tsulus migiteltel",
  "block.minecraft.banner.stripe_right.gray": "Gris migiteltel",
  "block.minecraft.banner.stripe_right.green": "Midori migiteltel",
  "block.minecraft.banner.stripe_right.light_blue": "Sini migiteltel",
  "block.minecraft.banner.stripe_right.light_gray": "Shirogris migiteltel",
  "block.minecraft.banner.stripe_right.lime": "Shiromidori migiteltel",
  "block.minecraft.banner.stripe_right.magenta": "Romura migiteltel",
  "block.minecraft.banner.stripe_right.orange": "Portokali migiteltel",
  "block.minecraft.banner.stripe_right.pink": "Roza migiteltel",
  "block.minecraft.banner.stripe_right.purple": "Muranen migiteltel",
  "block.minecraft.banner.stripe_right.red": "Ro migiteltel",
  "block.minecraft.banner.stripe_right.white": "Shiro migiteltel",
  "block.minecraft.banner.stripe_right.yellow": "Kiiro migiteltel",
  "block.minecraft.banner.stripe_top.black": "Kuro obatretel",
  "block.minecraft.banner.stripe_top.blue": "Blau obatretel",
  "block.minecraft.banner.stripe_top.brown": "Kafe obatretel",
  "block.minecraft.banner.stripe_top.cyan": "Tsulus obatretel",
  "block.minecraft.banner.stripe_top.gray": "Gris obatretel",
  "block.minecraft.banner.stripe_top.green": "Midori obatretel",
  "block.minecraft.banner.stripe_top.light_blue": "Sini obatretel",
  "block.minecraft.banner.stripe_top.light_gray": "Shirogris obatretel",
  "block.minecraft.banner.stripe_top.lime": "Shiromidori obatretel",
  "block.minecraft.banner.stripe_top.magenta": "Romura obatretel",
  "block.minecraft.banner.stripe_top.orange": "Portokali obatretel",
  "block.minecraft.banner.stripe_top.pink": "Roza obatretel",
  "block.minecraft.banner.stripe_top.purple": "Muranen obatretel",
  "block.minecraft.banner.stripe_top.red": "Ro obatretel",
  "block.minecraft.banner.stripe_top.white": "Shiro obatretel",
  "block.minecraft.banner.stripe_top.yellow": "Kiiro obatretel",
  "block.minecraft.banner.triangle_bottom.black": "Kuro unnatreik",
  "block.minecraft.banner.triangle_bottom.blue": "Blau unnatreik",
  "block.minecraft.banner.triangle_bottom.brown": "Kafe unnatreik",
  "block.minecraft.banner.triangle_bottom.cyan": "Tsulus unnatreik",
  "block.minecraft.banner.triangle_bottom.gray": "Gris unnatreik",
  "block.minecraft.banner.triangle_bottom.green": "Midori unnatreik",
  "block.minecraft.banner.triangle_bottom.light_blue": "Sini unnatreik",
  "block.minecraft.banner.triangle_bottom.light_gray": "Shirogris unnatreik",
  "block.minecraft.banner.triangle_bottom.lime": "Shiromidori unnatreik",
  "block.minecraft.banner.triangle_bottom.magenta": "Romura unnatreik",
  "block.minecraft.banner.triangle_bottom.orange": "Portokali unnatreik",
  "block.minecraft.banner.triangle_bottom.pink": "Roza unnatreik",
  "block.minecraft.banner.triangle_bottom.purple": "Muranen unnatreik",
  "block.minecraft.banner.triangle_bottom.red": "Ro unnatreik",
  "block.minecraft.banner.triangle_bottom.white": "Shiro unnatreik",
  "block.minecraft.banner.triangle_bottom.yellow": "Kiiro unnatreik",
  "block.minecraft.banner.triangle_top.black": "Kuro obatreik",
  "block.minecraft.banner.triangle_top.blue": "Blau obatreik",
  "block.minecraft.banner.triangle_top.brown": "Kafe obatreik",
  "block.minecraft.banner.triangle_top.cyan": "Tsulus obatreik",
  "block.minecraft.banner.triangle_top.gray": "Gris obatreik",
  "block.minecraft.banner.triangle_top.green": "Midori obatreik",
  "block.minecraft.banner.triangle_top.light_blue": "Sini obatreik",
  "block.minecraft.banner.triangle_top.light_gray": "Shirogris obatreik",
  "block.minecraft.banner.triangle_top.lime": "Shiromidori obatreik",
  "block.minecraft.banner.triangle_top.magenta": "Romura obatreik",
  "block.minecraft.banner.triangle_top.orange": "Portokali obatreik",
  "block.minecraft.banner.triangle_top.pink": "Roza obatreik",
  "block.minecraft.banner.triangle_top.purple": "Muranen obatreik",
  "block.minecraft.banner.triangle_top.red": "Ro obatreik",
  "block.minecraft.banner.triangle_top.white": "Shiro obatreik",
  "block.minecraft.banner.triangle_top.yellow": "Kiiro obatreik",
  "block.minecraft.banner.triangles_bottom.black": "Kuro unnatretel mitt hammas",
  "block.minecraft.banner.triangles_bottom.blue": "Blau unnatretel mitt hammas",
  "block.minecraft.banner.triangles_bottom.brown": "Kafe unnatretel mitt hammas",
  "block.minecraft.banner.triangles_bottom.cyan": "Tsulus unnatretel mitt hammas",
  "block.minecraft.banner.triangles_bottom.gray": "Gris unnatretel mitt hammas",
  "block.minecraft.banner.triangles_bottom.green": "Midori unnatretel mitt hammas",
  "block.minecraft.banner.triangles_bottom.light_blue": "Sini unnatretel mitt hammas",
  "block.minecraft.banner.triangles_bottom.light_gray": "Shirogris unnatretel mitt hammas",
  "block.minecraft.banner.triangles_bottom.lime": "Shiromidori unnatretel mitt hammas",
  "block.minecraft.banner.triangles_bottom.magenta": "Romura unnatretel mitt hammas",
  "block.minecraft.banner.triangles_bottom.orange": "Portokali unnatretel mitt hammas",
  "block.minecraft.banner.triangles_bottom.pink": "Roza unnatretel mitt hammas",
  "block.minecraft.banner.triangles_bottom.purple": "Muranen unnatretel mitt hammas",
  "block.minecraft.banner.triangles_bottom.red": "Ro unnatretel mitt hammas",
  "block.minecraft.banner.triangles_bottom.white": "Shiro unnatretel mitt hammas",
  "block.minecraft.banner.triangles_bottom.yellow": "Kiiro unnatretel mitt hammas",
  "block.minecraft.banner.triangles_top.black": "Kuro obatretel mitt hammas",
  "block.minecraft.banner.triangles_top.blue": "Blau obatretel mitt hammas",
  "block.minecraft.banner.triangles_top.brown": "Kafe obatretel mitt hammas",
  "block.minecraft.banner.triangles_top.cyan": "Tsulus obatretel mitt hammas",
  "block.minecraft.banner.triangles_top.gray": "Gris obatretel mitt hammas",
  "block.minecraft.banner.triangles_top.green": "Midori obatretel mitt hammas",
  "block.minecraft.banner.triangles_top.light_blue": "Sini obatretel mitt hammas",
  "block.minecraft.banner.triangles_top.light_gray": "Shirogris obatretel mitt hammas",
  "block.minecraft.banner.triangles_top.lime": "Shiromidori obatretel mitt hammas",
  "block.minecraft.banner.triangles_top.magenta": "Romura obatretel mitt hammas",
  "block.minecraft.banner.triangles_top.orange": "Portokali obatretel mitt hammas",
  "block.minecraft.banner.triangles_top.pink": "Roza obatretel mitt hammas",
  "block.minecraft.banner.triangles_top.purple": "Muranen obatretel mitt hammas",
  "block.minecraft.banner.triangles_top.red": "Ro obatretel mitt hammas",
  "block.minecraft.banner.triangles_top.white": "Shiro obatretel mitt hammas",
  "block.minecraft.banner.triangles_top.yellow": "Kiiro obatretel mitt hammas",
  "block.minecraft.barrel": "Badjeldai",
  "block.minecraft.barrier": "Jametumam",
  "block.minecraft.basalt": "Basalt",
  "block.minecraft.beacon": "Kirkasflakka",
  "block.minecraft.beacon.primary": "Eins taika",
  "block.minecraft.beacon.secondary": "Nis taika",
  "block.minecraft.bed.no_sleep": "Mono laki kola na naht au na zeusburja",
  "block.minecraft.bed.not_safe": "Nai laki ilta ima; jam mørkø para",
  "block.minecraft.bed.obstructed": "Afto bet tumamena",
  "block.minecraft.bed.occupied": "Afto bet ende sat",
  "block.minecraft.bed.too_far_away": "Nai laki ilta ima; bet-kara obapitka",
  "block.minecraft.bedrock": "Polishidai",
  "block.minecraft.bee_nest": "Melittavove",
  "block.minecraft.beehive": "Melittabaksu",
  "block.minecraft.beetroots": "Røranja",
  "block.minecraft.bell": "Zamklinje",
  "block.minecraft.big_dripleaf": "Stur ishkelehhti",
  "block.minecraft.big_dripleaf_stem": "Djido fu stur ishkelehhti",
  "block.minecraft.birch_button": "Volkodja presmi",
  "block.minecraft.birch_door": "Volkodja dvera",
  "block.minecraft.birch_fence": "Volkodja vjetkatumam",
  "block.minecraft.birch_fence_gate": "Volkodja vjetkadvera",
  "block.minecraft.birch_hanging_sign": "Volkozha shankotumam",
  "block.minecraft.birch_leaves": "Volkodjalehti",
  "block.minecraft.birch_log": "Volkodjadjido",
  "block.minecraft.birch_planks": "Volkodja baumtel",
  "block.minecraft.birch_pressure_plate": "Volkodja jalakatasta",
  "block.minecraft.birch_sapling": "Volkodja baumnen",
  "block.minecraft.birch_shelf": "Volkodja apal",
  "block.minecraft.birch_sign": "Volkozha kotumam",
  "block.minecraft.birch_slab": "Volkodja handado",
  "block.minecraft.birch_stairs": "Volkodja leo",
  "block.minecraft.birch_trapdoor": "Volkodja jalakadvera",
  "block.minecraft.birch_wall_hanging_sign": "Volkodja spada-kotumam shann tumam",
  "block.minecraft.birch_wall_sign": "Volkodja kotumam per tumam",
  "block.minecraft.birch_wood": "Volkodjabaum",
  "block.minecraft.black_banner": "Kuro flakka",
  "block.minecraft.black_bed": "Kuro bet",
  "block.minecraft.black_candle": "Kuro cheri",
  "block.minecraft.black_candle_cake": "Tórta mit kuro cheri",
  "block.minecraft.black_carpet": "Kuro lammaspol",
  "block.minecraft.black_concrete": "Kuro huomidado",
  "block.minecraft.black_concrete_powder": "Kuro huomishtof",
  "block.minecraft.black_glazed_terracotta": "Kuro vapajena glina",
  "block.minecraft.black_shulker_box": "Kuro Shulkerbaksu",
  "block.minecraft.black_stained_glass": "Kuro glas",
  "block.minecraft.black_stained_glass_pane": "Kuro glaslehti",
  "block.minecraft.black_terracotta": "Kuro glina",
  "block.minecraft.black_wool": "Kuro ul",
  "block.minecraft.blackstone": "Kuroishi",
  "block.minecraft.blackstone_slab": "Kuroishihandado",
  "block.minecraft.blackstone_stairs": "Kuroishi leo",
  "block.minecraft.blackstone_wall": "Kuroishi tumam",
  "block.minecraft.blast_furnace": "Erhonobet",
  "block.minecraft.blue_banner": "Blau flakka",
  "block.minecraft.blue_bed": "Blau bett",
  "block.minecraft.blue_candle": "Blau cheri",
  "block.minecraft.blue_candle_cake": "Tórta mit blau cheri",
  "block.minecraft.blue_carpet": "Blau lammaspol",
  "block.minecraft.blue_concrete": "Blau huomidado",
  "block.minecraft.blue_concrete_powder": "Blau huomishtof",
  "block.minecraft.blue_glazed_terracotta": "Blau vapajena glina",
  "block.minecraft.blue_ice": "Blau samuishke",
  "block.minecraft.blue_orchid": "Blau storcjik",
  "block.minecraft.blue_shulker_box": "Blau shulkerbaksu",
  "block.minecraft.blue_stained_glass": "Blau glas",
  "block.minecraft.blue_stained_glass_pane": "Blau glaslehti",
  "block.minecraft.blue_terracotta": "Blau glina",
  "block.minecraft.blue_wool": "Blau ul",
  "block.minecraft.bone_block": "Ponedado",
  "block.minecraft.bookshelf": "Libretumam",
  "block.minecraft.brain_coral": "Hjernegupkishi",
  "block.minecraft.brain_coral_block": "Hjernegupkishi-dado",
  "block.minecraft.brain_coral_fan": "Hjernegupkishi na tsubasa",
  "block.minecraft.brain_coral_wall_fan": "Hjernegupkishi tumamtsubasa",
  "block.minecraft.brewing_stand": "Ishketoreubma",
  "block.minecraft.brick_slab": "Gdent handado",
  "block.minecraft.brick_stairs": "Gdent leo",
  "block.minecraft.brick_wall": "Gdenttumam",
  "block.minecraft.bricks": "Gdent",
  "block.minecraft.brown_banner": "Kafe flakka",
  "block.minecraft.brown_bed": "Kafe bett",
  "block.minecraft.brown_candle": "Brun cheri",
  "block.minecraft.brown_candle_cake": "Tórta mit brun cheri",
  "block.minecraft.brown_carpet": "Kafe lammaspol",
  "block.minecraft.brown_concrete": "Kafe huomidado",
  "block.minecraft.brown_concrete_powder": "Kafe huomishtof",
  "block.minecraft.brown_glazed_terracotta": "Kafe vapajena glina",
  "block.minecraft.brown_mushroom": "Kafemanitari",
  "block.minecraft.brown_mushroom_block": "Kafe manitaridado",
  "block.minecraft.brown_shulker_box": "Kafe shulkerbaksu",
  "block.minecraft.brown_stained_glass": "Kafe glas",
  "block.minecraft.brown_stained_glass_pane": "Kafe glaslehti",
  "block.minecraft.brown_terracotta": "Kafe glina",
  "block.minecraft.brown_wool": "Kafe ul",
  "block.minecraft.bubble_column": "Luftmjah-tumam",
  "block.minecraft.bubble_coral": "Mjahgupkishi",
  "block.minecraft.bubble_coral_block": "Mjahgupkishi-dado",
  "block.minecraft.bubble_coral_fan": "Mjahgupkishi na tsubasa",
  "block.minecraft.bubble_coral_wall_fan": "Mjahgupkishi tumamtsubasa",
  "block.minecraft.budding_amethyst": "Petrasintwa Murakacha",
  "block.minecraft.bush": "Baumnen",
  "block.minecraft.cactus": "Puanlule",
  "block.minecraft.cactus_flower": "Sagarolule",
  "block.minecraft.cake": "Torta",
  "block.minecraft.calcite": "Zhunit",
  "block.minecraft.calibrated_sculk_sensor": "Tsatainena Aistiabma Sculk",
  "block.minecraft.campfire": "Honobetnen",
  "block.minecraft.candle": "Cheri",
  "block.minecraft.candle_cake": "Tórta mit cheri",
  "block.minecraft.carrots": "Karoten",
  "block.minecraft.cartography_table": "Kartaergostol",
  "block.minecraft.carved_pumpkin": "Achorfraut mitt kao",
  "block.minecraft.cauldron": "Tofdai",
  "block.minecraft.cave_air": "Sirangaluft",
  "block.minecraft.cave_vines": "Siranga spadaruti",
  "block.minecraft.cave_vines_plant": "Siranga spadaruti zhido",
  "block.minecraft.chain": "Rofaj",
  "block.minecraft.chain_command_block": "Rofaj jewaltdado",
  "block.minecraft.cherry_button": "Sakura tastanen",
  "block.minecraft.cherry_door": "Sakuradvera",
  "block.minecraft.cherry_fence": "Sakura-vjetkatumam",
  "block.minecraft.cherry_fence_gate": "Sakura-vjetkadvera",
  "block.minecraft.cherry_hanging_sign": "Sakura shankotumam",
  "block.minecraft.cherry_leaves": "Sakuralehti",
  "block.minecraft.cherry_log": "Sakuradjido",
  "block.minecraft.cherry_planks": "Sakura-baumtel",
  "block.minecraft.cherry_pressure_plate": "Sakura jalakatasta",
  "block.minecraft.cherry_sapling": "Sakura baumnen",
  "block.minecraft.cherry_shelf": "Sakura apal",
  "block.minecraft.cherry_sign": "Sakura kotumam",
  "block.minecraft.cherry_slab": "Sakura handado",
  "block.minecraft.cherry_stairs": "Sakura leo",
  "block.minecraft.cherry_trapdoor": "Sakura jalakadvera",
  "block.minecraft.cherry_wall_hanging_sign": "Sakura shankotumam shann tumam",
  "block.minecraft.cherry_wall_sign": "Sakura kotumam per tumam",
  "block.minecraft.cherry_wood": "Sakurabaum",
  "block.minecraft.chest": "Baksudai",
  "block.minecraft.chipped_anvil": "Bigorna perpenanen",
  "block.minecraft.chiseled_bookshelf": "Seresena libretumam",
  "block.minecraft.chiseled_copper": "Seresena kupkat",
  "block.minecraft.chiseled_deepslate": "Seresena idaun lehhtishi",
  "block.minecraft.chiseled_nether_bricks": "Seresena Nether gdent",
  "block.minecraft.chiseled_polished_blackstone": "Seresena Polena Kuroishi",
  "block.minecraft.chiseled_quartz_block": "Seresena kacha dado",
  "block.minecraft.chiseled_red_sandstone": "Seresena rosh sanishi",
  "block.minecraft.chiseled_resin_bricks": "Seresena mjaltpetra gdjent",
  "block.minecraft.chiseled_sandstone": "Seresena sanishi",
  "block.minecraft.chiseled_stone_bricks": "Seresena ishi gdent",
  "block.minecraft.chiseled_tuff": "Seresena fetemishi",
  "block.minecraft.chiseled_tuff_bricks": "Seresena fetemishi gdent",
  "block.minecraft.chorus_flower": "Sjansonlule",
  "block.minecraft.chorus_plant": "Sjansonruti",
  "block.minecraft.clay": "Glinater",
  "block.minecraft.closed_eyeblossom": "Kinijena Meblume",
  "block.minecraft.coal_block": "Kolmedado",
  "block.minecraft.coal_ore": "Kolmeranja",
  "block.minecraft.coarse_dirt": "Razishiter",
  "block.minecraft.cobbled_deepslate": "Idaun lehhtishinen",
  "block.minecraft.cobbled_deepslate_slab": "Handado na idaun lehhtishinen",
  "block.minecraft.cobbled_deepslate_stairs": "Leo na idaun lehhtishinen",
  "block.minecraft.cobbled_deepslate_wall": "Tumam na na idaun lehhtishinen",
  "block.minecraft.cobblestone": "Razishi",
  "block.minecraft.cobblestone_slab": "Ishinen handado",
  "block.minecraft.cobblestone_stairs": "Ishinenleo",
  "block.minecraft.cobblestone_wall": "Razishi tumam",
  "block.minecraft.cobweb": "Kashalka-Ryet",
  "block.minecraft.cocoa": "Shoki",
  "block.minecraft.command_block": "Jewaltdado",
  "block.minecraft.comparator": "Redstonesamacjigau",
  "block.minecraft.composter": "Mylbaksu",
  "block.minecraft.conduit": "Tsunagasen",
  "block.minecraft.copper_bars": "Kupkat rjettumam",
  "block.minecraft.copper_block": "Kupkat dado",
  "block.minecraft.copper_bulb": "Kupkat kruska",
  "block.minecraft.copper_chain": "Kupkat rofaj",
  "block.minecraft.copper_chest": "Kupkat baksu",
  "block.minecraft.copper_door": "Kupkat dvera",
  "block.minecraft.copper_golem_statue": "Kupkatbotto seres",
  "block.minecraft.copper_grate": "Kupkat rjet",
  "block.minecraft.copper_lantern": "Kupkat kirkaskline",
  "block.minecraft.copper_ore": "Kupkat ranja",
  "block.minecraft.copper_torch": "Vjetka kupkat",
  "block.minecraft.copper_trapdoor": "Kupkat jalakadvera",
  "block.minecraft.copper_wall_torch": "Vjetka kupkat na tumam",
  "block.minecraft.cornflower": "Maislule",
  "block.minecraft.cracked_deepslate_bricks": "Perpena idaunishi-gdent",
  "block.minecraft.cracked_deepslate_tiles": "Perpena idaunishi prehotel",
  "block.minecraft.cracked_nether_bricks": "Perpena Nether gdent",
  "block.minecraft.cracked_polished_blackstone_bricks": "Gdent na perpena polena kuroishi",
  "block.minecraft.cracked_stone_bricks": "Perpena ishigdent",
  "block.minecraft.crafter": "Anmahabma",
  "block.minecraft.crafting_table": "Mahastol",
  "block.minecraft.creaking_heart": "Ker f'Djidodjin",
  "block.minecraft.creeper_head": "Creeperatama",
  "block.minecraft.creeper_wall_head": "Creeperatama fu tumam",
  "block.minecraft.crimson_button": "Rodai tastanen",
  "block.minecraft.crimson_door": "Rodai dvera",
  "block.minecraft.crimson_fence": "Rodai vjetkatumam",
  "block.minecraft.crimson_fence_gate": "Rodai vjetkadvera",
  "block.minecraft.crimson_fungus": "Rodai manitari",
  "block.minecraft.crimson_hanging_sign": "Roshdai shankotumam",
  "block.minecraft.crimson_hyphae": "Rodaibaum",
  "block.minecraft.crimson_nylium": "Rodai faanitari",
  "block.minecraft.crimson_planks": "Rodaibaumtel",
  "block.minecraft.crimson_pressure_plate": "Rodai jalakatasta",
  "block.minecraft.crimson_roots": "Rodairanja",
  "block.minecraft.crimson_shelf": "Rodai apal",
  "block.minecraft.crimson_sign": "Rodai kotumam",
  "block.minecraft.crimson_slab": "Rodai handado",
  "block.minecraft.crimson_stairs": "Rodai leo",
  "block.minecraft.crimson_stem": "Rodaidjido",
  "block.minecraft.crimson_trapdoor": "Rodai jalakadvera",
  "block.minecraft.crimson_wall_hanging_sign": "Rodai shankotumam shann tumam",
  "block.minecraft.crimson_wall_sign": "Rodai kotumam per tumam",
  "block.minecraft.crying_obsidian": "Naku glasishi",
  "block.minecraft.cut_copper": "Tsamena kupkat",
  "block.minecraft.cut_copper_slab": "Tsamena kupkat handado",
  "block.minecraft.cut_copper_stairs": "Tsamena kupkatleo",
  "block.minecraft.cut_red_sandstone": "Rotsamsanishi",
  "block.minecraft.cut_red_sandstone_slab": "Handado tsamena røsanishi",
  "block.minecraft.cut_sandstone": "Tsamena sanishi",
  "block.minecraft.cut_sandstone_slab": "Handado na tsamena sanishi",
  "block.minecraft.cyan_banner": "Tsulus flakka",
  "block.minecraft.cyan_bed": "Tsulus bett",
  "block.minecraft.cyan_candle": "Tsulus cheri",
  "block.minecraft.cyan_candle_cake": "Tórta mit tsulus cheri",
  "block.minecraft.cyan_carpet": "Tsulus ylpol",
  "block.minecraft.cyan_concrete": "Tsulus huomidado",
  "block.minecraft.cyan_concrete_powder": "Tsulus huomishtof",
  "block.minecraft.cyan_glazed_terracotta": "Tsulus vapajena glina",
  "block.minecraft.cyan_shulker_box": "Tsulus shulkerbaksu",
  "block.minecraft.cyan_stained_glass": "Tsulus glas",
  "block.minecraft.cyan_stained_glass_pane": "Tsulus glaslehti",
  "block.minecraft.cyan_terracotta": "Tsulus glina",
  "block.minecraft.cyan_wool": "Tsulus ul",
  "block.minecraft.damaged_anvil": "Bigorna perpena",
  "block.minecraft.dandelion": "Kirolule",
  "block.minecraft.dark_oak_button": "Kurairus tastanen",
  "block.minecraft.dark_oak_door": "Kurairus dvera",
  "block.minecraft.dark_oak_fence": "Kurairus vjetkatumam",
  "block.minecraft.dark_oak_fence_gate": "Kurairus vjetkadvera",
  "block.minecraft.dark_oak_hanging_sign": "Kurairus shankotumam",
  "block.minecraft.dark_oak_leaves": "Kurairuslehti",
  "block.minecraft.dark_oak_log": "Kurairus-djido",
  "block.minecraft.dark_oak_planks": "Kurairusbaumtel",
  "block.minecraft.dark_oak_pressure_plate": "Kurairus jalakatasta",
  "block.minecraft.dark_oak_sapling": "Kurairus baumnen",
  "block.minecraft.dark_oak_shelf": "Kurairus apal",
  "block.minecraft.dark_oak_sign": "Kurairus kotumam",
  "block.minecraft.dark_oak_slab": "Kurairus handado",
  "block.minecraft.dark_oak_stairs": "Kurairus leo",
  "block.minecraft.dark_oak_trapdoor": "Kurairus jalakadvera",
  "block.minecraft.dark_oak_wall_hanging_sign": "Kurairus shankotumam shann tumam",
  "block.minecraft.dark_oak_wall_sign": "Kurairus kotumam per tumam",
  "block.minecraft.dark_oak_wood": "Kurairus-baum",
  "block.minecraft.dark_prismarine": "Kuraiprizmarin",
  "block.minecraft.dark_prismarine_slab": "Idaunishi handado",
  "block.minecraft.dark_prismarine_stairs": "Leo na Kuraiprizmarin",
  "block.minecraft.daylight_detector": "Anlerabma fu solkirkas",
  "block.minecraft.dead_brain_coral": "Shinu-hjernegupkishi",
  "block.minecraft.dead_brain_coral_block": "Shinu dado fu hjerne-gupkishi",
  "block.minecraft.dead_brain_coral_fan": "Tsubasa na shinu-hjernegupkishi",
  "block.minecraft.dead_brain_coral_wall_fan": "Shinu tumamlehti fu hjerne-gupkishi",
  "block.minecraft.dead_bubble_coral": "Shinu-mjahgupkishi",
  "block.minecraft.dead_bubble_coral_block": "Shinu dado fu mjah-gupkishi",
  "block.minecraft.dead_bubble_coral_fan": "Tsubasa na shinu-mjahgupkishi",
  "block.minecraft.dead_bubble_coral_wall_fan": "Shinu tumamlehti fu Mjah-gupkishi",
  "block.minecraft.dead_bush": "Shinu baumnen",
  "block.minecraft.dead_fire_coral": "Shinu-honoogupkishi",
  "block.minecraft.dead_fire_coral_block": "Shinu dado fu honoo-gupkishi",
  "block.minecraft.dead_fire_coral_fan": "Tsubasa na shinu-honoogupkishi",
  "block.minecraft.dead_fire_coral_wall_fan": "Shinu tumamlehti honoo-gupkishi",
  "block.minecraft.dead_horn_coral": "Shinu-norgupkishi",
  "block.minecraft.dead_horn_coral_block": "Shinu dado fu nor-gupkishi",
  "block.minecraft.dead_horn_coral_fan": "Tsubasa na shinu-norgupkishi",
  "block.minecraft.dead_horn_coral_wall_fan": "Shinu tumamlehti fu nor-gupkishi",
  "block.minecraft.dead_tube_coral": "Gwangupkishi shinunetopa",
  "block.minecraft.dead_tube_coral_block": "Shinu-gwangupkishi dado",
  "block.minecraft.dead_tube_coral_fan": "Tsubasa na shinu-gwangupkishi",
  "block.minecraft.dead_tube_coral_wall_fan": "Shinu tumamlehti fu gwan-gupkishi",
  "block.minecraft.decorated_pot": "Razrisoena luleklinge",
  "block.minecraft.deepslate": "Idaun lehhtishi",
  "block.minecraft.deepslate_brick_slab": "Idaunishi-gdent handado",
  "block.minecraft.deepslate_brick_stairs": "Idaunishi gdent leo",
  "block.minecraft.deepslate_brick_wall": "Idaunishi-gdent tumam",
  "block.minecraft.deepslate_bricks": "Gdent na idaun lehhtishi",
  "block.minecraft.deepslate_coal_ore": "Kolmeranja na idaun lehhtishi",
  "block.minecraft.deepslate_copper_ore": "Idaun lehhtishi kupkatranja",
  "block.minecraft.deepslate_diamond_ore": "Idaun helenishiranja",
  "block.minecraft.deepslate_emerald_ore": "Idaun zomorozranja",
  "block.minecraft.deepslate_gold_ore": "Kelkatranja na idaun lehhtishi",
  "block.minecraft.deepslate_iron_ore": "Jerkatranja na idaun lehtishi",
  "block.minecraft.deepslate_lapis_ore": "Idaun blaushtof-ranja",
  "block.minecraft.deepslate_redstone_ore": "Idaun lehhtishi redstone ranja",
  "block.minecraft.deepslate_tile_slab": "Handado na idaunishi prehotel",
  "block.minecraft.deepslate_tile_stairs": "Leo na idaunishi prehotel",
  "block.minecraft.deepslate_tile_wall": "Tumam na idaunishi prehotel",
  "block.minecraft.deepslate_tiles": "Idaunishi prehotel",
  "block.minecraft.detector_rail": "Uaistia-naruga",
  "block.minecraft.diamond_block": "Helenaishi-dado",
  "block.minecraft.diamond_ore": "Helenaishiranja",
  "block.minecraft.diorite": "Diorit",
  "block.minecraft.diorite_slab": "Handado na diorit",
  "block.minecraft.diorite_stairs": "Dioritleo",
  "block.minecraft.diorite_wall": "Diorit tumam",
  "block.minecraft.dirt": "Ter",
  "block.minecraft.dirt_path": "Ternaruga",
  "block.minecraft.dispenser": "Antadado",
  "block.minecraft.dragon_egg": "Rjuujaitso",
  "block.minecraft.dragon_head": "Rjuuatama",
  "block.minecraft.dragon_wall_head": "Rjuu tumamatama",
  "block.minecraft.dried_ghast": "Gandzau Ghast",
  "block.minecraft.dried_kelp_block": "Marekaalidado",
  "block.minecraft.dripstone_block": "Pluishi",
  "block.minecraft.dropper": "Spaadabaksu",
  "block.minecraft.emerald_block": "Zomorozdado",
  "block.minecraft.emerald_ore": "Zomorozranja",
  "block.minecraft.enchanting_table": "Taikastol",
  "block.minecraft.end_gateway": "Endidveranen",
  "block.minecraft.end_portal": "End-dveradai",
  "block.minecraft.end_portal_frame": "Enddveratel",
  "block.minecraft.end_rod": "End-vjetka",
  "block.minecraft.end_stone": "Endishi",
  "block.minecraft.end_stone_brick_slab": "End-ishi gdenthandado",
  "block.minecraft.end_stone_brick_stairs": "Endishi Gdentleo",
  "block.minecraft.end_stone_brick_wall": "End-ishi gdenttumam",
  "block.minecraft.end_stone_bricks": "End ishi gdent",
  "block.minecraft.ender_chest": "Enderbaksu",
  "block.minecraft.exposed_chiseled_copper": "Djangenanen seresena kupkat",
  "block.minecraft.exposed_copper": "Pojhangena kupkat",
  "block.minecraft.exposed_copper_bars": "Djangenanen Kupkat Rjettumam",
  "block.minecraft.exposed_copper_bulb": "Djangenanen kupkat kruska",
  "block.minecraft.exposed_copper_chain": "Djangenanen kupkat festa",
  "block.minecraft.exposed_copper_chest": "Djangenanen kupkat baksu",
  "block.minecraft.exposed_copper_door": "Djangenanen kupkat dvera",
  "block.minecraft.exposed_copper_golem_statue": "Djangenanen kupkatbotto seres",
  "block.minecraft.exposed_copper_grate": "Djangenanen kupkat rjet",
  "block.minecraft.exposed_copper_lantern": "Djangenanen kupkat kirkaskline",
  "block.minecraft.exposed_copper_trapdoor": "Djangenanen kupkat jalakadvera",
  "block.minecraft.exposed_cut_copper": "Pojhangena tsamena kupkat",
  "block.minecraft.exposed_cut_copper_slab": "Handado na pojhangena tsamena kupkat",
  "block.minecraft.exposed_cut_copper_stairs": "Pojhangena tsamena kupkatleo",
  "block.minecraft.exposed_lightning_rod": "Djangenanen zeus-zikhavjetka",
  "block.minecraft.farmland": "Nuntsang",
  "block.minecraft.fern": "Hantlehti",
  "block.minecraft.fire": "Hono",
  "block.minecraft.fire_coral": "Honoogupkishi",
  "block.minecraft.fire_coral_block": "Honoogupkishi-dado",
  "block.minecraft.fire_coral_fan": "Honoogupkishi na tsubasa",
  "block.minecraft.fire_coral_wall_fan": "Honoogupkishi tumamtsubasa",
  "block.minecraft.firefly_bush": "Kirkasbagge baumnen",
  "block.minecraft.fletching_table": "Strelastol",
  "block.minecraft.flower_pot": "Luleklinje",
  "block.minecraft.flowering_azalea": "Luleazalea",
  "block.minecraft.flowering_azalea_leaves": "Lehti fu luleazalija",
  "block.minecraft.frogspawn": "Eg fu baba",
  "block.minecraft.frosted_ice": "Razitjena samuishke",
  "block.minecraft.furnace": "Honobet",
  "block.minecraft.gilded_blackstone": "Geltkuroishi",
  "block.minecraft.glass": "Glas",
  "block.minecraft.glass_pane": "Glasmado",
  "block.minecraft.glow_lichen": "Kiragira gribkodja",
  "block.minecraft.glowstone": "Kirkasishi",
  "block.minecraft.gold_block": "Geltjerkatdado",
  "block.minecraft.gold_ore": "Keltranja",
  "block.minecraft.golden_dandelion": "Gelt Kirolule",
  "block.minecraft.granite": "Granit",
  "block.minecraft.granite_slab": "Handado na granit",
  "block.minecraft.granite_stairs": "Granitleo",
  "block.minecraft.granite_wall": "Granittumam",
  "block.minecraft.grass": "Mun",
  "block.minecraft.grass_block": "Mundado",
  "block.minecraft.gravel": "Ishisan",
  "block.minecraft.gray_banner": "Gris flakka",
  "block.minecraft.gray_bed": "Gris bett",
  "block.minecraft.gray_candle": "Gris cheri",
  "block.minecraft.gray_candle_cake": "Tórta mit gris cheri",
  "block.minecraft.gray_carpet": "Gris lammaspol",
  "block.minecraft.gray_concrete": "Gris huomidado",
  "block.minecraft.gray_concrete_powder": "Gris huomishtof",
  "block.minecraft.gray_glazed_terracotta": "Gris vapajena glina",
  "block.minecraft.gray_shulker_box": "Gris shulkerbaksu",
  "block.minecraft.gray_stained_glass": "Gris glas",
  "block.minecraft.gray_stained_glass_pane": "Gris glaslehti",
  "block.minecraft.gray_terracotta": "Gris glina",
  "block.minecraft.gray_wool": "Gris ul",
  "block.minecraft.green_banner": "Midori flakka",
  "block.minecraft.green_bed": "Midori bett",
  "block.minecraft.green_candle": "Midori cheri",
  "block.minecraft.green_candle_cake": "Tórta mit midori cheri",
  "block.minecraft.green_carpet": "Midori lammaspol",
  "block.minecraft.green_concrete": "Midori huomidado",
  "block.minecraft.green_concrete_powder": "Midori huomishtof",
  "block.minecraft.green_glazed_terracotta": "Midori vapajena glina",
  "block.minecraft.green_shulker_box": "Midori shulkerbaksu",
  "block.minecraft.green_stained_glass": "Midori glas",
  "block.minecraft.green_stained_glass_pane": "Midori glaslehti",
  "block.minecraft.green_terracotta": "Midori glina",
  "block.minecraft.green_wool": "Midori ul",
  "block.minecraft.grindstone": "Razugokishi",
  "block.minecraft.hanging_roots": "Shangranja",
  "block.minecraft.hay_block": "Djotrimun",
  "block.minecraft.heavy_core": "Veht Kersa",
  "block.minecraft.heavy_weighted_pressure_plate": "Jalakatasta mit vehtdwaibma",
  "block.minecraft.honey_block": "Mjaltdado",
  "block.minecraft.honeycomb_block": "Mjaltrjetdado",
  "block.minecraft.hopper": "Bidrabma",
  "block.minecraft.horn_coral": "Norgupkishi",
  "block.minecraft.horn_coral_block": "Norgupkishi-dado",
  "block.minecraft.horn_coral_fan": "Norgupkishi na tsubasa",
  "block.minecraft.horn_coral_wall_fan": "Norgupkishi tumamtsubasa",
  "block.minecraft.ice": "Samuishke",
  "block.minecraft.infested_chiseled_stone_bricks": "Flan seresena ishigdent",
  "block.minecraft.infested_cobblestone": "Flan ishinen",
  "block.minecraft.infested_cracked_stone_bricks": "Flan perpena ishigdent",
  "block.minecraft.infested_deepslate": "Flan idaun lehhtishi",
  "block.minecraft.infested_mossy_stone_bricks": "Flan mungodjena ishigdent",
  "block.minecraft.infested_stone": "Flan ishi",
  "block.minecraft.infested_stone_bricks": "Flan ishi gdent",
  "block.minecraft.iron_bars": "Jerkat rjettumam",
  "block.minecraft.iron_block": "Jerkatishidado",
  "block.minecraft.iron_chain": "Jerkat rofaj",
  "block.minecraft.iron_door": "Jerkatdvera",
  "block.minecraft.iron_ore": "Jerkatranja",
  "block.minecraft.iron_trapdoor": "Jerkat jalakadvera",
  "block.minecraft.jack_o_lantern": "Achorkirkaskran",
  "block.minecraft.jigsaw": "Falcherdado",
  "block.minecraft.jukebox": "Spilbaksu",
  "block.minecraft.jungle_button": "Pluidasos tastanen",
  "block.minecraft.jungle_door": "Pluidasos dvera",
  "block.minecraft.jungle_fence": "Pluidasos vjetkatumam",
  "block.minecraft.jungle_fence_gate": "Pluidasos vjetkadvera",
  "block.minecraft.jungle_hanging_sign": "Pluidasos shankotumam",
  "block.minecraft.jungle_leaves": "Pluidasoslehti",
  "block.minecraft.jungle_log": "Pluidasos-djido",
  "block.minecraft.jungle_planks": "Pluidasos-baumtel",
  "block.minecraft.jungle_pressure_plate": "Pluidasos jalakatasta",
  "block.minecraft.jungle_sapling": "Pluidasos baumnen",
  "block.minecraft.jungle_shelf": "Pluidasos apal",
  "block.minecraft.jungle_sign": "Pluidasos kotumam",
  "block.minecraft.jungle_slab": "Pluidasos handado",
  "block.minecraft.jungle_stairs": "Pluidasos leo",
  "block.minecraft.jungle_trapdoor": "Pluidasos jalakadvera",
  "block.minecraft.jungle_wall_hanging_sign": "Pluidasos shankotumam shann tumam",
  "block.minecraft.jungle_wall_sign": "Pluidasos kotumam per tumam",
  "block.minecraft.jungle_wood": "Pluidasos-baum",
  "block.minecraft.kelp": "Marekaali",
  "block.minecraft.kelp_plant": "Ruti fu Marekaali",
  "block.minecraft.ladder": "Tumamleo",
  "block.minecraft.lantern": "Kirkasklinje",
  "block.minecraft.lapis_block": "Blaushtofdado",
  "block.minecraft.lapis_ore": "Blaushtofranja",
  "block.minecraft.large_amethyst_bud": "Stur murakacha petrapie",
  "block.minecraft.large_fern": "Stuur hantlehti",
  "block.minecraft.lava": "Zjotishke",
  "block.minecraft.lava_cauldron": "Tofdai fu zjotishke",
  "block.minecraft.leaf_litter": "Djotrilehti",
  "block.minecraft.lectern": "Librestol",
  "block.minecraft.lever": "Kapdai",
  "block.minecraft.light": "Kirkas",
  "block.minecraft.light_blue_banner": "Sini flakka",
  "block.minecraft.light_blue_bed": "Sini bett",
  "block.minecraft.light_blue_candle": "Sini cheri",
  "block.minecraft.light_blue_candle_cake": "Tórta mit sini cheri",
  "block.minecraft.light_blue_carpet": "Sini lammaspol",
  "block.minecraft.light_blue_concrete": "Sini huomidado",
  "block.minecraft.light_blue_concrete_powder": "Sini huomishtof",
  "block.minecraft.light_blue_glazed_terracotta": "Sini vapajena glina",
  "block.minecraft.light_blue_shulker_box": "Sini shulkerbaksu",
  "block.minecraft.light_blue_stained_glass": "Sini glas",
  "block.minecraft.light_blue_stained_glass_pane": "Sini glaslehti",
  "block.minecraft.light_blue_terracotta": "Sini glina",
  "block.minecraft.light_blue_wool": "Sini ul",
  "block.minecraft.light_gray_banner": "Shirogris flakka",
  "block.minecraft.light_gray_bed": "Shirogris bett",
  "block.minecraft.light_gray_candle": "Shirogris cheri",
  "block.minecraft.light_gray_candle_cake": "Tórta mit shirogris cheri",
  "block.minecraft.light_gray_carpet": "Shirogris lammaspol",
  "block.minecraft.light_gray_concrete": "Shirogris huomidado",
  "block.minecraft.light_gray_concrete_powder": "Shirogris huomishtof",
  "block.minecraft.light_gray_glazed_terracotta": "Shirogris vapajena glina",
  "block.minecraft.light_gray_shulker_box": "Shirogris shulkerbaksu",
  "block.minecraft.light_gray_stained_glass": "Shirogris glas",
  "block.minecraft.light_gray_stained_glass_pane": "Shirogris glaslehti",
  "block.minecraft.light_gray_terracotta": "Shirogris glina",
  "block.minecraft.light_gray_wool": "Shirogris ul",
  "block.minecraft.light_weighted_pressure_plate": "Jalakatasta mit lihtdwaibma",
  "block.minecraft.lightning_rod": "Zeus-zikhavjetka",
  "block.minecraft.lilac": "Murasakinen",
  "block.minecraft.lily_of_the_valley": "Tanilule",
  "block.minecraft.lily_pad": "Ishkelule-pol",
  "block.minecraft.lime_banner": "Shiromidori flakka",
  "block.minecraft.lime_bed": "Shiromidori bett",
  "block.minecraft.lime_candle": "Shiromidori cheri",
  "block.minecraft.lime_candle_cake": "Tórta mit shiromidori cheri",
  "block.minecraft.lime_carpet": "Shiromidori lammaspol",
  "block.minecraft.lime_concrete": "Shiromidori huomidado",
  "block.minecraft.lime_concrete_powder": "Shiromidori huomishtof",
  "block.minecraft.lime_glazed_terracotta": "Shiromidori vapajena glina",
  "block.minecraft.lime_shulker_box": "Shiromidori shulkerbaksu",
  "block.minecraft.lime_stained_glass": "Shiromidori glas",
  "block.minecraft.lime_stained_glass_pane": "Shiromidori glaslehti",
  "block.minecraft.lime_terracotta": "Shiromidori glina",
  "block.minecraft.lime_wool": "Shiromidori ul",
  "block.minecraft.lodestone": "Plasdado",
  "block.minecraft.loom": "Ul-dwaibma",
  "block.minecraft.magenta_banner": "Romura flakka",
  "block.minecraft.magenta_bed": "Romura bett",
  "block.minecraft.magenta_candle": "Romura cheri",
  "block.minecraft.magenta_candle_cake": "Tórta mit romura cheri",
  "block.minecraft.magenta_carpet": "Romura ylpol",
  "block.minecraft.magenta_concrete": "Romura huomidado",
  "block.minecraft.magenta_concrete_powder": "Romura huomishtof",
  "block.minecraft.magenta_glazed_terracotta": "Romura vapajena glina",
  "block.minecraft.magenta_shulker_box": "Romura shulkerbaksu",
  "block.minecraft.magenta_stained_glass": "Romura glas",
  "block.minecraft.magenta_stained_glass_pane": "Romura glaslehti",
  "block.minecraft.magenta_terracotta": "Romura glina",
  "block.minecraft.magenta_wool": "Romura ul",
  "block.minecraft.magma_block": "Zjotishi dado",
  "block.minecraft.mangrove_button": "Presmi na mangr",
  "block.minecraft.mangrove_door": "Dera na mangr",
  "block.minecraft.mangrove_fence": "Mangra vjetkatumam",
  "block.minecraft.mangrove_fence_gate": "Vjetkadvera fu mangr",
  "block.minecraft.mangrove_hanging_sign": "Shangchatto na mangra",
  "block.minecraft.mangrove_leaves": "Lehtimangra",
  "block.minecraft.mangrove_log": "Mangrdjido",
  "block.minecraft.mangrove_planks": "Baumtel fu mangra",
  "block.minecraft.mangrove_pressure_plate": "Tastalasku na mangr",
  "block.minecraft.mangrove_propagule": "Piedai fu mangr",
  "block.minecraft.mangrove_roots": "Mangriranja",
  "block.minecraft.mangrove_shelf": "Mangr apal",
  "block.minecraft.mangrove_sign": "Chatto na mangr",
  "block.minecraft.mangrove_slab": "Mangr handado",
  "block.minecraft.mangrove_stairs": "Leo na mangr",
  "block.minecraft.mangrove_trapdoor": "Jalakadera na mangr",
  "block.minecraft.mangrove_wall_hanging_sign": "Tumam-shangchatto na mangra",
  "block.minecraft.mangrove_wall_sign": "Tumam-chatto na mangr",
  "block.minecraft.mangrove_wood": "Mangrbaum",
  "block.minecraft.medium_amethyst_bud": "Mellan murakacha petrapie",
  "block.minecraft.melon": "Ishkefraut",
  "block.minecraft.melon_stem": "Ishkefraut-djido",
  "block.minecraft.moss_block": "Mungodjena dado",
  "block.minecraft.moss_carpet": "Mungodja pol",
  "block.minecraft.mossy_cobblestone": "Mungodjena razishi",
  "block.minecraft.mossy_cobblestone_slab": "Mungodjena razishi handado",
  "block.minecraft.mossy_cobblestone_stairs": "Mungodjena razishi leo",
  "block.minecraft.mossy_cobblestone_wall": "Mungodjena razishi tumam",
  "block.minecraft.mossy_stone_brick_slab": "Mungodjena ishigdent handado",
  "block.minecraft.mossy_stone_brick_stairs": "Mungodjena ishi gdentleo",
  "block.minecraft.mossy_stone_brick_wall": "Mungodjena ishigdent tumam",
  "block.minecraft.mossy_stone_bricks": "Mungodjena ishigdent",
  "block.minecraft.moving_piston": "Ugoki zehant",
  "block.minecraft.mud": "Pantano",
  "block.minecraft.mud_brick_slab": "Handado na pantanogdent",
  "block.minecraft.mud_brick_stairs": "Pantano gdent leo",
  "block.minecraft.mud_brick_wall": "Pantano gdent tumam",
  "block.minecraft.mud_bricks": "Pantanogdent",
  "block.minecraft.muddy_mangrove_roots": "Pantanoena ranja mangra",
  "block.minecraft.mushroom_stem": "Yalakanen manitari",
  "block.minecraft.mycelium": "Manitarimun",
  "block.minecraft.nether_brick_fence": "Nethergdent vjetkatumam",
  "block.minecraft.nether_brick_slab": "Handado na Nether gdent",
  "block.minecraft.nether_brick_stairs": "Nethergdent leo",
  "block.minecraft.nether_brick_wall": "Nether gdent tumam",
  "block.minecraft.nether_bricks": "Nethergdent",
  "block.minecraft.nether_gold_ore": "Nether-geltranja",
  "block.minecraft.nether_portal": "Netherdvera",
  "block.minecraft.nether_quartz_ore": "Nether kacharanja",
  "block.minecraft.nether_sprouts": "Nethermunnen",
  "block.minecraft.nether_wart": "Netherlule",
  "block.minecraft.nether_wart_block": "Netherluledado",
  "block.minecraft.netherite_block": "Nethershtofdado",
  "block.minecraft.netherrack": "Netherrack",
  "block.minecraft.note_block": "Nuotidado",
  "block.minecraft.oak_button": "Rus presmi",
  "block.minecraft.oak_door": "Rus dvera",
  "block.minecraft.oak_fence": "Rus vjetkatumam",
  "block.minecraft.oak_fence_gate": "Rus vjetkadvera",
  "block.minecraft.oak_hanging_sign": "Rus shankotumam",
  "block.minecraft.oak_leaves": "Ruslehti",
  "block.minecraft.oak_log": "Rusdjido",
  "block.minecraft.oak_planks": "Rus-baumtel",
  "block.minecraft.oak_pressure_plate": "Rus jalakatasta",
  "block.minecraft.oak_sapling": "Rus baumnen",
  "block.minecraft.oak_shelf": "Rus apal",
  "block.minecraft.oak_sign": "Rus kotumam",
  "block.minecraft.oak_slab": "Rus handado",
  "block.minecraft.oak_stairs": "Rus leo",
  "block.minecraft.oak_trapdoor": "Rus jalakadvera",
  "block.minecraft.oak_wall_hanging_sign": "Rus spadakotumam shann tumam",
  "block.minecraft.oak_wall_sign": "Rus kotumam na tumam",
  "block.minecraft.oak_wood": "Rusbaum",
  "block.minecraft.observer": "Anaistiabma",
  "block.minecraft.obsidian": "Kuraiglas",
  "block.minecraft.ochre_froglight": "Okra babagkirkas",
  "block.minecraft.ominous_banner": "Flakka mitt udacjikokoro",
  "block.minecraft.open_eyeblossom": "Aukijena Meblume",
  "block.minecraft.orange_banner": "Portokali flakka",
  "block.minecraft.orange_bed": "Portokali bett",
  "block.minecraft.orange_candle": "Portokali cheri",
  "block.minecraft.orange_candle_cake": "Tórta mit portokali cheri",
  "block.minecraft.orange_carpet": "Portokali ylpol",
  "block.minecraft.orange_concrete": "Portokali huomidado",
  "block.minecraft.orange_concrete_powder": "Portokali huomishtof",
  "block.minecraft.orange_glazed_terracotta": "Portokali vapajena glina",
  "block.minecraft.orange_shulker_box": "Portokali shulkerbaksu",
  "block.minecraft.orange_stained_glass": "Portokali glas",
  "block.minecraft.orange_stained_glass_pane": "Portokali glaslehti",
  "block.minecraft.orange_terracotta": "Portokali glina",
  "block.minecraft.orange_tulip": "Portokali tulipan",
  "block.minecraft.orange_wool": "Portokali ul",
  "block.minecraft.oxeye_daisy": "Gjuumenen",
  "block.minecraft.oxidized_chiseled_copper": "Erdjangena seresena kupkat",
  "block.minecraft.oxidized_copper": "Heljhangena kupkat",
  "block.minecraft.oxidized_copper_bars": "Erdjangena Kupkat Rjettumam",
  "block.minecraft.oxidized_copper_bulb": "Erdjangena kupkat kruska",
  "block.minecraft.oxidized_copper_chain": "Erdjangena kupkat festa",
  "block.minecraft.oxidized_copper_chest": "Erdjangena kupkat baksu",
  "block.minecraft.oxidized_copper_door": "Erdjangena kupkat dvera",
  "block.minecraft.oxidized_copper_golem_statue": "Erdjangena kupkatbotto seres",
  "block.minecraft.oxidized_copper_grate": "Erdjangena kupkat rjet",
  "block.minecraft.oxidized_copper_lantern": "Erdjangena kupkat kirkaskline",
  "block.minecraft.oxidized_copper_trapdoor": "Erdjangena kupkat jalakadvera",
  "block.minecraft.oxidized_cut_copper": "Heljhangena tsamena kupkat",
  "block.minecraft.oxidized_cut_copper_slab": "Handado na heljhangena tsamena kupkat",
  "block.minecraft.oxidized_cut_copper_stairs": "Heljhangena tsamena kupkatleo",
  "block.minecraft.oxidized_lightning_rod": "Erdjangena zeus-zikhavjetka",
  "block.minecraft.packed_ice": "Gutsjena samuishke",
  "block.minecraft.packed_mud": "Gushena pantano",
  "block.minecraft.pale_hanging_moss": "Shiromungodja shangranja",
  "block.minecraft.pale_moss_block": "Shiro mungodjena dado",
  "block.minecraft.pale_moss_carpet": "Shiro mungodja pol",
  "block.minecraft.pale_oak_button": "Shirorus tastanen",
  "block.minecraft.pale_oak_door": "Shirorus dvera",
  "block.minecraft.pale_oak_fence": "Shirorus vjetkatumam",
  "block.minecraft.pale_oak_fence_gate": "Shirorus vjetkadvera",
  "block.minecraft.pale_oak_hanging_sign": "Shirorus shankotumam",
  "block.minecraft.pale_oak_leaves": "Shiroruslehti",
  "block.minecraft.pale_oak_log": "Shirorusdjido",
  "block.minecraft.pale_oak_planks": "Shirorusbaumtel",
  "block.minecraft.pale_oak_pressure_plate": "Shirorus jalakatasta",
  "block.minecraft.pale_oak_sapling": "Shirorus baumnen",
  "block.minecraft.pale_oak_shelf": "Shirurus apal",
  "block.minecraft.pale_oak_sign": "Shirorus kotumam",
  "block.minecraft.pale_oak_slab": "Shirorus handado",
  "block.minecraft.pale_oak_stairs": "Shirorus leo",
  "block.minecraft.pale_oak_trapdoor": "Shirorus jalakadvera",
  "block.minecraft.pale_oak_wall_hanging_sign": "Shirorus shakotumam shann tumam",
  "block.minecraft.pale_oak_wall_sign": "Shirorus kotumam na tumam",
  "block.minecraft.pale_oak_wood": "Shirorusbaum",
  "block.minecraft.pearlescent_froglight": "Peitralik baba-kirkas",
  "block.minecraft.peony": "Pivonia",
  "block.minecraft.petrified_oak_slab": "Ishiøzena Rus Poltel",
  "block.minecraft.piglin_head": "Atama Piglina",
  "block.minecraft.piglin_wall_head": "Tumamatama fu Piglina",
  "block.minecraft.pink_banner": "Roza flakka",
  "block.minecraft.pink_bed": "Roza bett",
  "block.minecraft.pink_candle": "Roza cheri",
  "block.minecraft.pink_candle_cake": "Tórta mit roza cheri",
  "block.minecraft.pink_carpet": "Roza lammaspol",
  "block.minecraft.pink_concrete": "Roza huomidado",
  "block.minecraft.pink_concrete_powder": "Roza huomishtof",
  "block.minecraft.pink_glazed_terracotta": "Roza vapajena glina",
  "block.minecraft.pink_petals": "Roza blumeeshtof",
  "block.minecraft.pink_shulker_box": "Roza shulkerbaksu",
  "block.minecraft.pink_stained_glass": "Roza glas",
  "block.minecraft.pink_stained_glass_pane": "Roza glaslehti",
  "block.minecraft.pink_terracotta": "Roza glina",
  "block.minecraft.pink_tulip": "Roza tulipan",
  "block.minecraft.pink_wool": "Roza ul",
  "block.minecraft.piston": "Zehant",
  "block.minecraft.piston_head": "Zehantnen",
  "block.minecraft.pitcher_crop": "Ovashi fu klingjeruti",
  "block.minecraft.pitcher_plant": "Klingjeruti",
  "block.minecraft.player_head": "Atama fu spildjin",
  "block.minecraft.player_head.named": "Atama fu %s",
  "block.minecraft.player_wall_head": "Tumamatama fu spildjin",
  "block.minecraft.podzol": "Padzól",
  "block.minecraft.pointed_dripstone": "Pwann fu pluishi",
  "block.minecraft.polished_andesite": "Polena andesit",
  "block.minecraft.polished_andesite_slab": "Handado na polena andesit",
  "block.minecraft.polished_andesite_stairs": "Leo fu polena andesit",
  "block.minecraft.polished_basalt": "Polena basalt",
  "block.minecraft.polished_blackstone": "Polena kuroishi",
  "block.minecraft.polished_blackstone_brick_slab": "Handado na polena kuroishi-gdent",
  "block.minecraft.polished_blackstone_brick_stairs": "Leo na polena kuroishi-gdent",
  "block.minecraft.polished_blackstone_brick_wall": "Tumam na polena kuroishi-gdent",
  "block.minecraft.polished_blackstone_bricks": "Gdent na polena kuroishi",
  "block.minecraft.polished_blackstone_button": "Tasta na polena kuroishi",
  "block.minecraft.polished_blackstone_pressure_plate": "Jalakatasta na polena kuroishi",
  "block.minecraft.polished_blackstone_slab": "Handado na polena kuroishi",
  "block.minecraft.polished_blackstone_stairs": "Leo na polena kuroishi",
  "block.minecraft.polished_blackstone_wall": "Tumam na polena kuroishi",
  "block.minecraft.polished_deepslate": "Polena idaunishi",
  "block.minecraft.polished_deepslate_slab": "Handado na polena Idaunishi",
  "block.minecraft.polished_deepslate_stairs": "Leo na polena idaunishi",
  "block.minecraft.polished_deepslate_wall": "Tumam na polena idaunishi",
  "block.minecraft.polished_diorite": "Polenadiorit",
  "block.minecraft.polished_diorite_slab": "Handado na polena diorit",
  "block.minecraft.polished_diorite_stairs": "Polenadiorit-leo",
  "block.minecraft.polished_granite": "Polenagranit",
  "block.minecraft.polished_granite_slab": "Handado na polena granit",
  "block.minecraft.polished_granite_stairs": "Polenagranit-leo",
  "block.minecraft.polished_tuff": "Polena fetemishi",
  "block.minecraft.polished_tuff_slab": "Handado na polena fetemishi",
  "block.minecraft.polished_tuff_stairs": "Leo fu polena fetemishi",
  "block.minecraft.polished_tuff_wall": "Tumam na polena fetemishi",
  "block.minecraft.poppy": "Kriiglule",
  "block.minecraft.potatoes": "Kartofel",
  "block.minecraft.potted_acacia_sapling": "Akakjabaumnen klinjena",
  "block.minecraft.potted_allium": "Loklule klinjena",
  "block.minecraft.potted_azalea_bush": "Klinjena azalija",
  "block.minecraft.potted_azure_bluet": "Blaunen klinjena",
  "block.minecraft.potted_bamboo": "Sembaum klinjena",
  "block.minecraft.potted_birch_sapling": "Volkodjabaumnen klinjena",
  "block.minecraft.potted_blue_orchid": "Blauhelena klinjena",
  "block.minecraft.potted_brown_mushroom": "Kafemanitari klinjena",
  "block.minecraft.potted_cactus": "Pwanlule klinjena",
  "block.minecraft.potted_cherry_sapling": "Sakurabaumnen klinjena",
  "block.minecraft.potted_closed_eyeblossom": "Klinjena Kinijena Meblume",
  "block.minecraft.potted_cornflower": "Maislule klinjena",
  "block.minecraft.potted_crimson_fungus": "Rodai manitari klinjena",
  "block.minecraft.potted_crimson_roots": "Rodairanja klinjena",
  "block.minecraft.potted_dandelion": "Kirolule klinjena",
  "block.minecraft.potted_dark_oak_sapling": "Kurairusbaumnen klinjena",
  "block.minecraft.potted_dead_bush": "Shinurazvjetka klinjena",
  "block.minecraft.potted_fern": "Hantlehti klinjena",
  "block.minecraft.potted_flowering_azalea_bush": "Klingena luleazalija",
  "block.minecraft.potted_golden_dandelion": "Gelt Kirolule Klinjena",
  "block.minecraft.potted_jungle_sapling": "Klinjena baumnen fu pluidasos",
  "block.minecraft.potted_lily_of_the_valley": "Tanilule klinjena",
  "block.minecraft.potted_mangrove_propagule": "Piedai fu mangr klinjena",
  "block.minecraft.potted_oak_sapling": "Rusbaumnen klinjena",
  "block.minecraft.potted_open_eyeblossom": "Klinjena Aukijena Meblume",
  "block.minecraft.potted_orange_tulip": "Portokali simpellule klinjena",
  "block.minecraft.potted_oxeye_daisy": "Gjuumenen klinjena",
  "block.minecraft.potted_pale_oak_sapling": "Shirorusbaumnen klinjena",
  "block.minecraft.potted_pink_tulip": "Rózafarje simpellule klinjena",
  "block.minecraft.potted_poppy": "Kriiglule klinjena",
  "block.minecraft.potted_red_mushroom": "Romanitari klinjena",
  "block.minecraft.potted_red_tulip": "Ro simpellule klinjena",
  "block.minecraft.potted_spruce_sapling": "Julbaumnen klinjena",
  "block.minecraft.potted_torchflower": "Klinjena kirkasblume",
  "block.minecraft.potted_warped_fungus": "Erstranitari klinjena",
  "block.minecraft.potted_warped_roots": "Erstrani ranja klinjena",
  "block.minecraft.potted_white_tulip": "Shiro simpellule klinjena",
  "block.minecraft.potted_wither_rose": "Witherlule klinjena",
  "block.minecraft.powder_snow": "Alkupash",
  "block.minecraft.powder_snow_cauldron": "Tofdai fu alk upash",
  "block.minecraft.powered_rail": "Zejerkatnaruga",
  "block.minecraft.prismarine": "Prizmarin",
  "block.minecraft.prismarine_brick_slab": "Prizmarin gdent handado",
  "block.minecraft.prismarine_brick_stairs": "Prizmarin gdent leo",
  "block.minecraft.prismarine_bricks": "Prizmarin gdent",
  "block.minecraft.prismarine_slab": "Prizmarin handado",
  "block.minecraft.prismarine_stairs": "Prizmarin leo",
  "block.minecraft.prismarine_wall": "Prizmarin tumam",
  "block.minecraft.pumpkin": "Achorfraut",
  "block.minecraft.pumpkin_stem": "Achorfrautdjido",
  "block.minecraft.purple_banner": "Muranen flakka",
  "block.minecraft.purple_bed": "Muranen bett",
  "block.minecraft.purple_candle": "Muranen cheri",
  "block.minecraft.purple_candle_cake": "Tórta mit muranen cheri",
  "block.minecraft.purple_carpet": "Muranen lammaspol",
  "block.minecraft.purple_concrete": "Muranen huomidado",
  "block.minecraft.purple_concrete_powder": "Muranen huomishtof",
  "block.minecraft.purple_glazed_terracotta": "Muranen vapajena glina",
  "block.minecraft.purple_shulker_box": "Muranen shulkerbaksu",
  "block.minecraft.purple_stained_glass": "Muranen glas",
  "block.minecraft.purple_stained_glass_pane": "Muranen glaslehti",
  "block.minecraft.purple_terracotta": "Muranen glina",
  "block.minecraft.purple_wool": "Muranen ul",
  "block.minecraft.purpur_block": "Purpur dado",
  "block.minecraft.purpur_pillar": "Purpurtumam",
  "block.minecraft.purpur_slab": "Purpurteldado",
  "block.minecraft.purpur_stairs": "Purpurleo",
  "block.minecraft.quartz_block": "Kacha dado",
  "block.minecraft.quartz_bricks": "Kachagdent",
  "block.minecraft.quartz_pillar": "Kacha djido",
  "block.minecraft.quartz_slab": "Kacha handado",
  "block.minecraft.quartz_stairs": "Kacha leo",
  "block.minecraft.rail": "Jerkatnaruga",
  "block.minecraft.raw_copper_block": "Dado fu yttengotova kupkat",
  "block.minecraft.raw_gold_block": "Yttengotova geltkat dado",
  "block.minecraft.raw_iron_block": "Yttengotova jerkat dado",
  "block.minecraft.red_banner": "Ro flakka",
  "block.minecraft.red_bed": "Ro bett",
  "block.minecraft.red_candle": "Ro cheri",
  "block.minecraft.red_candle_cake": "Tórta mit ro cheri",
  "block.minecraft.red_carpet": "Ro lammaspol",
  "block.minecraft.red_concrete": "Ro huomidado",
  "block.minecraft.red_concrete_powder": "Ro huomishtof",
  "block.minecraft.red_glazed_terracotta": "Ro vapajena glina",
  "block.minecraft.red_mushroom": "Romanitari",
  "block.minecraft.red_mushroom_block": "Ro manitaridado",
  "block.minecraft.red_nether_brick_slab": "Rosh nether gdent handado",
  "block.minecraft.red_nether_brick_stairs": "Ro nether gdent leo",
  "block.minecraft.red_nether_brick_wall": "Ro nether gdent tumam",
  "block.minecraft.red_nether_bricks": "Ro nether gdent",
  "block.minecraft.red_sand": "Rosan",
  "block.minecraft.red_sandstone": "Rosandado",
  "block.minecraft.red_sandstone_slab": "Rosanhantel",
  "block.minecraft.red_sandstone_stairs": "Rosanleo",
  "block.minecraft.red_sandstone_wall": "Rosantumam",
  "block.minecraft.red_shulker_box": "Ro shulkerbaksu",
  "block.minecraft.red_stained_glass": "Ro glas",
  "block.minecraft.red_stained_glass_pane": "Ro glaslehti",
  "block.minecraft.red_terracotta": "Ro glina",
  "block.minecraft.red_tulip": "Ro tulipan",
  "block.minecraft.red_wool": "Ro ul",
  "block.minecraft.redstone_block": "Redstone dado",
  "block.minecraft.redstone_lamp": "Redstone kirkas",
  "block.minecraft.redstone_ore": "Redstone ranja",
  "block.minecraft.redstone_torch": "Redstone vjetka",
  "block.minecraft.redstone_wall_torch": "Redstone vjetka na tumam",
  "block.minecraft.redstone_wire": "Redstone zesen",
  "block.minecraft.reinforced_deepslate": "Zhongena idaunishi",
  "block.minecraft.repeater": "Redstonevent",
  "block.minecraft.repeating_command_block": "Razgjensuru jewaltdado",
  "block.minecraft.resin_block": "Mjaltpetra dado",
  "block.minecraft.resin_brick_slab": "Mjaltpetra gdjent handado",
  "block.minecraft.resin_brick_stairs": "Mjaltpetra gdjent leo",
  "block.minecraft.resin_brick_wall": "Mjaltpetra gdjent tumam",
  "block.minecraft.resin_bricks": "Mjaltpetra gdjent",
  "block.minecraft.resin_clump": "Mjaltpetramjah",
  "block.minecraft.respawn_anchor": "Gjensintuadado",
  "block.minecraft.rooted_dirt": "Ter mit ranja",
  "block.minecraft.rose_bush": "Rozarazlule",
  "block.minecraft.sand": "San",
  "block.minecraft.sandstone": "Sanishi",
  "block.minecraft.sandstone_slab": "Sanishi handado",
  "block.minecraft.sandstone_stairs": "Sanleo",
  "block.minecraft.sandstone_wall": "Santumam",
  "block.minecraft.scaffolding": "Rjetpol",
  "block.minecraft.sculk": "Sculk",
  "block.minecraft.sculk_catalyst": "Sculk errufnedvaibma",
  "block.minecraft.sculk_sensor": "Aistiabma Sculk",
  "block.minecraft.sculk_shrieker": "Sculk shreibma",
  "block.minecraft.sculk_vein": "Sculk gwannen",
  "block.minecraft.sea_lantern": "Mare-kirkaskran",
  "block.minecraft.sea_pickle": "Havkjuri",
  "block.minecraft.seagrass": "Havmun",
  "block.minecraft.set_spawn": "Gjensintuaplas kawarena",
  "block.minecraft.short_dry_grass": "Djotri hobitmun",
  "block.minecraft.short_grass": "Hobit mun",
  "block.minecraft.shroomlight": "Manitarikirkas",
  "block.minecraft.shulker_box": "Shulkerbaksu",
  "block.minecraft.skeleton_skull": "Atama fu ponedjin",
  "block.minecraft.skeleton_wall_skull": "Atama fu ponedjin na tumam",
  "block.minecraft.slime_block": "Gymi dado",
  "block.minecraft.small_amethyst_bud": "Chiçai murakacha petrapie",
  "block.minecraft.small_dripleaf": "Chiçai ishkelehhti",
  "block.minecraft.smithing_table": "Stol per jerkatergo",
  "block.minecraft.smoker": "Honokumobma",
  "block.minecraft.smooth_basalt": "Pollik basalt",
  "block.minecraft.smooth_quartz": "Pollik Kachadado",
  "block.minecraft.smooth_quartz_slab": "Pollik kacha handado",
  "block.minecraft.smooth_quartz_stairs": "Pollik kacha leo",
  "block.minecraft.smooth_red_sandstone": "Ro Sanishi",
  "block.minecraft.smooth_red_sandstone_slab": "Rosanfuwahandado",
  "block.minecraft.smooth_red_sandstone_stairs": "Leo na ro sanishi",
  "block.minecraft.smooth_sandstone": "Pollik sanishi",
  "block.minecraft.smooth_sandstone_slab": "Handado na polena sanishi",
  "block.minecraft.smooth_sandstone_stairs": "Leo na polena sanishi",
  "block.minecraft.smooth_stone": "Pollik ishi",
  "block.minecraft.smooth_stone_slab": "Handado na pollik ishi",
  "block.minecraft.sniffer_egg": "Jaitso fu nioidjin",
  "block.minecraft.snow": "Upash",
  "block.minecraft.snow_block": "Upashdado",
  "block.minecraft.soul_campfire": "Shalhonobetnen",
  "block.minecraft.soul_fire": "Shalhono",
  "block.minecraft.soul_lantern": "Shalkirkasklinje",
  "block.minecraft.soul_sand": "Shalsan",
  "block.minecraft.soul_soil": "Sjal-ter",
  "block.minecraft.soul_torch": "Shalkirkasvjetka",
  "block.minecraft.soul_wall_torch": "Shalkirkasvjetka na tumam",
  "block.minecraft.spawn.not_valid": "Har nil huomibett os nil gjensintua-festena mit zeus, os jam men tumamena",
  "block.minecraft.spawner": "Mørkø sintuabma",
  "block.minecraft.spawner.desc1": "Bruk sintuajaitso:",
  "block.minecraft.spawner.desc2": "Jewald fal fu vonashal",
  "block.minecraft.sponge": "Glubka",
  "block.minecraft.spore_blossom": "Alkpje lulenen",
  "block.minecraft.spruce_button": "Jul presmi",
  "block.minecraft.spruce_door": "Jul dvera",
  "block.minecraft.spruce_fence": "Jul vjetkatumam",
  "block.minecraft.spruce_fence_gate": "Jul vjetkadvera",
  "block.minecraft.spruce_hanging_sign": "Jul shankotumam",
  "block.minecraft.spruce_leaves": "Jullehti",
  "block.minecraft.spruce_log": "Juldjido",
  "block.minecraft.spruce_planks": "Jul baumtel",
  "block.minecraft.spruce_pressure_plate": "Jul jalakatasta",
  "block.minecraft.spruce_sapling": "Julbaumnen",
  "block.minecraft.spruce_shelf": "Jul apal",
  "block.minecraft.spruce_sign": "Jul kotumam",
  "block.minecraft.spruce_slab": "Jul handado",
  "block.minecraft.spruce_stairs": "Jul leo",
  "block.minecraft.spruce_trapdoor": "Jul jalakadvera",
  "block.minecraft.spruce_wall_hanging_sign": "Jul shan-kotumam tumam-shang",
  "block.minecraft.spruce_wall_sign": "Jul kotumam na tumam",
  "block.minecraft.spruce_wood": "Julbaum",
  "block.minecraft.sticky_piston": "Mjaltlik hantnen",
  "block.minecraft.stone": "Ishi",
  "block.minecraft.stone_brick_slab": "Ishigdent handado",
  "block.minecraft.stone_brick_stairs": "Ishigdent leo",
  "block.minecraft.stone_brick_wall": "Ishi gdent tumam",
  "block.minecraft.stone_bricks": "Ishi gdent",
  "block.minecraft.stone_button": "Ishi presmi",
  "block.minecraft.stone_pressure_plate": "Ishi jalakatasta",
  "block.minecraft.stone_slab": "Ishi-handado",
  "block.minecraft.stone_stairs": "Ishileo",
  "block.minecraft.stonecutter": "Ishicheribma",
  "block.minecraft.stripped_acacia_log": "Utengodja akakjadjido",
  "block.minecraft.stripped_acacia_wood": "Utengodja akakjabaum",
  "block.minecraft.stripped_bamboo_block": "Utnkozha sembaumdado",
  "block.minecraft.stripped_birch_log": "Utengodja volkodjadjido",
  "block.minecraft.stripped_birch_wood": "Utengodja volkodjabaum",
  "block.minecraft.stripped_cherry_log": "Utengodja sakuradjido",
  "block.minecraft.stripped_cherry_wood": "Utengodja sakurabaum",
  "block.minecraft.stripped_crimson_hyphae": "Utengodja rodaibaum",
  "block.minecraft.stripped_crimson_stem": "Utengodja rodaidjido",
  "block.minecraft.stripped_dark_oak_log": "Utengodja kurairusdjido",
  "block.minecraft.stripped_dark_oak_wood": "Utengodja kurairus-baum",
  "block.minecraft.stripped_jungle_log": "Utengodja pluidasos-djido",
  "block.minecraft.stripped_jungle_wood": "Utengodja pluidasos-baum",
  "block.minecraft.stripped_mangrove_log": "Utenkozhena mangrdjido",
  "block.minecraft.stripped_mangrove_wood": "Knkozhena baum fu mangra",
  "block.minecraft.stripped_oak_log": "Utengodja rusdjido",
  "block.minecraft.stripped_oak_wood": "Utengodja rusbaum",
  "block.minecraft.stripped_pale_oak_log": "Utengodja shirorusdjido",
  "block.minecraft.stripped_pale_oak_wood": "Utengodja shirorusbaum",
  "block.minecraft.stripped_spruce_log": "Utengodja juldjido",
  "block.minecraft.stripped_spruce_wood": "Utengodja yulbaum",
  "block.minecraft.stripped_warped_hyphae": "Utengodja erstrani baum",
  "block.minecraft.stripped_warped_stem": "Utengodja erstrani djido",
  "block.minecraft.structure_block": "Polfaldado",
  "block.minecraft.structure_void": "Polfal oharedado",
  "block.minecraft.sugar_cane": "Sokkeridjido",
  "block.minecraft.sunflower": "Sollule",
  "block.minecraft.suspicious_gravel": "Susishisan",
  "block.minecraft.suspicious_sand": "Sussan",
  "block.minecraft.sweet_berry_bush": "Frautnenrazvjetka",
  "block.minecraft.tall_dry_grass": "Djotri pitkamun",
  "block.minecraft.tall_grass": "Pitkamun",
  "block.minecraft.tall_seagrass": "Pitkahavmun",
  "block.minecraft.target": "Jenadado",
  "block.minecraft.terracotta": "Glina",
  "block.minecraft.test_block": "Iskatdado",
  "block.minecraft.test_instance_block": "Eiiskatdado",
  "block.minecraft.tinted_glass": "Kurai Glas",
  "block.minecraft.tnt": "Bamdado",
  "block.minecraft.tnt.disabled": "Bamdado lakinai",
  "block.minecraft.torch": "Kirkasvjetka",
  "block.minecraft.torchflower": "Kirkasblume",
  "block.minecraft.torchflower_crop": "Kirkasblume ruti",
  "block.minecraft.trapped_chest": "Uwakibaksu",
  "block.minecraft.trial_spawner": "Iskatdai Sintuabma",
  "block.minecraft.tripwire": "Spadanoito",
  "block.minecraft.tripwire_hook": "Spadanoitofesta",
  "block.minecraft.tube_coral": "Gwangupkishi",
  "block.minecraft.tube_coral_block": "Gwangupkishi-dado",
  "block.minecraft.tube_coral_fan": "Gwangupkishi na tsubasa",
  "block.minecraft.tube_coral_wall_fan": "Gwangupkishi tumamtsubasa",
  "block.minecraft.tuff": "Fetemishi",
  "block.minecraft.tuff_brick_slab": "Fetemishi gdent handado",
  "block.minecraft.tuff_brick_stairs": "Fetemishi gdent leo",
  "block.minecraft.tuff_brick_wall": "Fetemishi gdent tumam",
  "block.minecraft.tuff_bricks": "Fetemishi gdent",
  "block.minecraft.tuff_slab": "Fetemishi handado",
  "block.minecraft.tuff_stairs": "Fetemishileo",
  "block.minecraft.tuff_wall": "Fetemishitumam",
  "block.minecraft.turtle_egg": "Breshkajaitso",
  "block.minecraft.twisting_vines": "Raskrungut spadaruti",
  "block.minecraft.twisting_vines_plant": "Raskrungut spadaruti zhido",
  "block.minecraft.vault": "Ziharum",
  "block.minecraft.verdant_froglight": "Midorinen babakirkas",
  "block.minecraft.vine": "Spadaruti",
  "block.minecraft.void_air": "Avaradado",
  "block.minecraft.wall_torch": "Tumamkirkasvjetka",
  "block.minecraft.warped_button": "Erstrani tastanen",
  "block.minecraft.warped_door": "Erstrani dvera",
  "block.minecraft.warped_fence": "Erstrani vjetkatumam",
  "block.minecraft.warped_fence_gate": "Erstrani vjetkadvera",
  "block.minecraft.warped_fungus": "Erstranitari",
  "block.minecraft.warped_hanging_sign": "Erstrani shankotumam",
  "block.minecraft.warped_hyphae": "Erstranibaum",
  "block.minecraft.warped_nylium": "Erstrani faanitari",
  "block.minecraft.warped_planks": "Erstrani baumshtof",
  "block.minecraft.warped_pressure_plate": "Erstrani jalakatasta",
  "block.minecraft.warped_roots": "Erstrani ranja",
  "block.minecraft.warped_shelf": "Erstrani apal",
  "block.minecraft.warped_sign": "Erstrani kotumam",
  "block.minecraft.warped_slab": "Erstrani handado",
  "block.minecraft.warped_stairs": "Erstrani leo",
  "block.minecraft.warped_stem": "Erstrani djido",
  "block.minecraft.warped_trapdoor": "Erstrani jalakadvera",
  "block.minecraft.warped_wall_hanging_sign": "Erstrani spada-kotumam shann tumam",
  "block.minecraft.warped_wall_sign": "Erstrani kotumam shann tumam",
  "block.minecraft.warped_wart_block": "Erstrani luledado",
  "block.minecraft.water": "Ishke",
  "block.minecraft.water_cauldron": "Tofdai fu ishke",
  "block.minecraft.waxed_chiseled_copper": "Dreshena seresena kupkat",
  "block.minecraft.waxed_copper_bars": "Dreshena Kupkat Rjettumam",
  "block.minecraft.waxed_copper_block": "Dreshena kupkat dado",
  "block.minecraft.waxed_copper_bulb": "Dreshena kupkat kruska",
  "block.minecraft.waxed_copper_chain": "Dreshena kupkat festa",
  "block.minecraft.waxed_copper_chest": "Dreshena kupkat baksu",
  "block.minecraft.waxed_copper_door": "Dreshena kupkat dvera",
  "block.minecraft.waxed_copper_golem_statue": "Dreshena kupkatbotto seres",
  "block.minecraft.waxed_copper_grate": "Dreshena kupkat rjet",
  "block.minecraft.waxed_copper_lantern": "Dreshena kupkat kirkaskline",
  "block.minecraft.waxed_copper_trapdoor": "Dreshena kupkat jalakadvera",
  "block.minecraft.waxed_cut_copper": "Dreshena tsamena kupkat",
  "block.minecraft.waxed_cut_copper_slab": "Dreshena tsamena kupkat handado",
  "block.minecraft.waxed_cut_copper_stairs": "Dreshena tsamena kupkat leo",
  "block.minecraft.waxed_exposed_chiseled_copper": "Dreshena djangenanen seresena kupkat",
  "block.minecraft.waxed_exposed_copper": "Dreshena pojhangena kupkat",
  "block.minecraft.waxed_exposed_copper_bars": "Dreshena Djangenanen Kupkat Rjettumam",
  "block.minecraft.waxed_exposed_copper_bulb": "Dreshena djangenanen kupkat kruska",
  "block.minecraft.waxed_exposed_copper_chain": "Dreshena djangenanen kupkat festa",
  "block.minecraft.waxed_exposed_copper_chest": "Dreshena djangenanen kupkat baksu",
  "block.minecraft.waxed_exposed_copper_door": "Dreshena djangenanen kupkat dvera",
  "block.minecraft.waxed_exposed_copper_golem_statue": "Dreshena djangenanen kupkatbotto seres",
  "block.minecraft.waxed_exposed_copper_grate": "Dreshena djangenanen kupkat rjet",
  "block.minecraft.waxed_exposed_copper_lantern": "Dreshena djangenanen kupkat kirkaskline",
  "block.minecraft.waxed_exposed_copper_trapdoor": "Dreshena djangenanen kupkat jalakadvera",
  "block.minecraft.waxed_exposed_cut_copper": "Dreshena pojhangena tsamena kupkat",
  "block.minecraft.waxed_exposed_cut_copper_slab": "Dreshena pojhangena tsamena kupkat handado",
  "block.minecraft.waxed_exposed_cut_copper_stairs": "Dreshena pojhangena tsamena kupkat leo",
  "block.minecraft.waxed_exposed_lightning_rod": "Dreshena djangenanen zeus-zikhavjetka",
  "block.minecraft.waxed_lightning_rod": "Dreshena zeus-zikhavjetka",
  "block.minecraft.waxed_oxidized_chiseled_copper": "Dreshena erdjangena seresena kupkat",
  "block.minecraft.waxed_oxidized_copper": "Dreshena Heljhangena kupkat",
  "block.minecraft.waxed_oxidized_copper_bars": "Dreshena Erdjangena Kupkat Rjettumam",
  "block.minecraft.waxed_oxidized_copper_bulb": "Dreshena erdjangena kukpat kruska",
  "block.minecraft.waxed_oxidized_copper_chain": "Dreshena erdjangena kupkat festa",
  "block.minecraft.waxed_oxidized_copper_chest": "Dreshena erdjangena kupkat baksu",
  "block.minecraft.waxed_oxidized_copper_door": "Dreshena erdjangena kupkat dvera",
  "block.minecraft.waxed_oxidized_copper_golem_statue": "Dreshena erdjangena kupkatbotto seres",
  "block.minecraft.waxed_oxidized_copper_grate": "Dreshena erdjangena kupkat rjet",
  "block.minecraft.waxed_oxidized_copper_lantern": "Dreshena erdjangena kupkat kirksaskline",
  "block.minecraft.waxed_oxidized_copper_trapdoor": "Dreshena erdjangena kupkat jalakadvera",
  "block.minecraft.waxed_oxidized_cut_copper": "Dreshena heljhangena tsamena kupkat",
  "block.minecraft.waxed_oxidized_cut_copper_slab": "Dreshena heljhangena tsamena kupkat handado",
  "block.minecraft.waxed_oxidized_cut_copper_stairs": "Dreshena heljhangena tsamena kupkat leo",
  "block.minecraft.waxed_oxidized_lightning_rod": "Dreshena erdjangena zeus-zikhavjetka",
  "block.minecraft.waxed_weathered_chiseled_copper": "Dreshena djangenadai seresena kupkat",
  "block.minecraft.waxed_weathered_copper": "Dreshena erjhangena kupkat",
  "block.minecraft.waxed_weathered_copper_bars": "Dreshena Djangenadai Kupkat Rjettumam",
  "block.minecraft.waxed_weathered_copper_bulb": "Dreshena djangenadai kupkat kruska",
  "block.minecraft.waxed_weathered_copper_chain": "Dreshena djangenadai kupkat festa",
  "block.minecraft.waxed_weathered_copper_chest": "Dreshena djangenadai kupkat baksu",
  "block.minecraft.waxed_weathered_copper_door": "Dreshena djangenadai kupkat dvera",
  "block.minecraft.waxed_weathered_copper_golem_statue": "Dreshena djangenadai kupkatbotto seres",
  "block.minecraft.waxed_weathered_copper_grate": "Dreshena djangenadai kupkat rjet",
  "block.minecraft.waxed_weathered_copper_lantern": "Dreshena djangenadai kupkat kirkaskline",
  "block.minecraft.waxed_weathered_copper_trapdoor": "Dreshena djangenadai kupkat jalakadvera",
  "block.minecraft.waxed_weathered_cut_copper": "Dreshena erjhangena tsamena kupkat",
  "block.minecraft.waxed_weathered_cut_copper_slab": "Dreshena erjhangena kupkat handado",
  "block.minecraft.waxed_weathered_cut_copper_stairs": "Dreshena erjhangena tsamena kupkat leo",
  "block.minecraft.waxed_weathered_lightning_rod": "Dreshena djangenadai zeus-zikhavjetka",
  "block.minecraft.weathered_chiseled_copper": "Djangenadai seresena kupkat",
  "block.minecraft.weathered_copper": "Erjhangena kupkat",
  "block.minecraft.weathered_copper_bars": "Djangenadai Kupkat Rjettumam",
  "block.minecraft.weathered_copper_bulb": "djangenadai kupkat kruska",
  "block.minecraft.weathered_copper_chain": "Djangenadai kupkat festa",
  "block.minecraft.weathered_copper_chest": "Djangenadai kupkat baksu",
  "block.minecraft.weathered_copper_door": "Djangenadai kupkat dvera",
  "block.minecraft.weathered_copper_golem_statue": "Djangenadaj kupkatbotto seres",
  "block.minecraft.weathered_copper_grate": "Djangenadai kupkat rjet",
  "block.minecraft.weathered_copper_lantern": "Djangenadai kupkat kirkaskline",
  "block.minecraft.weathered_copper_trapdoor": "Djangenadai kupkat jalakadvera",
  "block.minecraft.weathered_cut_copper": "Erjhangena tsamena kupkat",
  "block.minecraft.weathered_cut_copper_slab": "Erjhangena tsamena kupkat handado",
  "block.minecraft.weathered_cut_copper_stairs": "Erjhangena tsamena kupkat leo",
  "block.minecraft.weathered_lightning_rod": "Djangenadai zeus-zikhavjetka",
  "block.minecraft.weeping_vines": "Nakuspadaruti",
  "block.minecraft.weeping_vines_plant": "Naku spadaruti",
  "block.minecraft.wet_sponge": "Mokri glubka",
  "block.minecraft.wheat": "Ruti Panmun",
  "block.minecraft.white_banner": "Shiro flakka",
  "block.minecraft.white_bed": "Shiro bett",
  "block.minecraft.white_candle": "Shiro cheri",
  "block.minecraft.white_candle_cake": "Tórta mit shiro cheri",
  "block.minecraft.white_carpet": "Shiro lammaspol",
  "block.minecraft.white_concrete": "Shiro huomidado",
  "block.minecraft.white_concrete_powder": "Shiro huomishtof",
  "block.minecraft.white_glazed_terracotta": "Shiro vapajena glina",
  "block.minecraft.white_shulker_box": "Shiro shulkerbaksu",
  "block.minecraft.white_stained_glass": "Shiro glas",
  "block.minecraft.white_stained_glass_pane": "Shiro glaslehti",
  "block.minecraft.white_terracotta": "Shiro glina",
  "block.minecraft.white_tulip": "Shiro tulipan",
  "block.minecraft.white_wool": "Shiro ul",
  "block.minecraft.wildflowers": "Dasoslule",
  "block.minecraft.wither_rose": "Witherlule",
  "block.minecraft.wither_skeleton_skull": "Witherponedjin atama",
  "block.minecraft.wither_skeleton_wall_skull": "Atama fu witherponedjin na tumam",
  "block.minecraft.yellow_banner": "Kiiro flakka",
  "block.minecraft.yellow_bed": "Kiiro bett",
  "block.minecraft.yellow_candle": "Kiiro cheri",
  "block.minecraft.yellow_candle_cake": "Tórta mit kiiro cheri",
  "block.minecraft.yellow_carpet": "Kiiro ylpol",
  "block.minecraft.yellow_concrete": "Kiiro huomidado",
  "block.minecraft.yellow_concrete_powder": "Kiiro huomishtof",
  "block.minecraft.yellow_glazed_terracotta": "Kiiro vapajena glina",
  "block.minecraft.yellow_shulker_box": "Kiiro shulkerbaksu",
  "block.minecraft.yellow_stained_glass": "Kiiro glas",
  "block.minecraft.yellow_stained_glass_pane": "Kiiro glaslehti",
  "block.minecraft.yellow_terracotta": "Kiiro glina",
  "block.minecraft.yellow_wool": "Kiiro ul",
  "block.minecraft.zombie_head": "Odarematama",
  "block.minecraft.zombie_wall_head": "Tumamatama fu Piglina",
  "item.minecraft.acacia_boat": "Akakja cjip",
  "item.minecraft.acacia_chest_boat": "Akakja cjip mit baksu",
  "item.minecraft.allay_spawn_egg": "Sintuajaitso f'Apudjin",
  "item.minecraft.amethyst_shard": "Tel fu murakacha",
  "item.minecraft.angler_pottery_shard": "Sakanadjin luleklignetel",
  "item.minecraft.angler_pottery_sherd": "Sakanadjin luleklignetel",
  "item.minecraft.apple": "Ringo",
  "item.minecraft.archer_pottery_shard": "Lunadjin luleklignetel",
  "item.minecraft.archer_pottery_sherd": "Lunadjin luleklignetel",
  "item.minecraft.armadillo_scute": "Komuskepone fu komushemysh",
  "item.minecraft.armadillo_spawn_egg": "Sintuajaitso f'Komuskemysh",
  "item.minecraft.armor_stand": "Kømuskebaum",
  "item.minecraft.arms_up_pottery_shard": "Hantiwai luleklignetel",
  "item.minecraft.arms_up_pottery_sherd": "Hantiwai luleklignetel",
  "item.minecraft.arrow": "Strela",
  "item.minecraft.axolotl_bucket": "Badjel mit atheksetl",
  "item.minecraft.axolotl_spawn_egg": "Sintuajaitso f'Atheksetl",
  "item.minecraft.baked_potato": "Toreukartofel",
  "item.minecraft.bamboo_chest_raft": "Sembaum chipnen mit baksu",
  "item.minecraft.bamboo_raft": "Sembaum chipnen",
  "item.minecraft.bat_spawn_egg": "Sintuajaitso f'Ljetamys",
  "item.minecraft.bee_spawn_egg": "Sintuajaitso f'Melitta",
  "item.minecraft.beef": "Gju yttengotova",
  "item.minecraft.beetroot": "Røranja",
  "item.minecraft.beetroot_seeds": "Røranjapie",
  "item.minecraft.beetroot_soup": "Røranjasta",
  "item.minecraft.birch_boat": "Volkodja cjip",
  "item.minecraft.birch_chest_boat": "Volkodja chip mit baksu",
  "item.minecraft.black_bundle": "Kuro festakaban",
  "item.minecraft.black_dye": "Kuro faria",
  "item.minecraft.black_harness": "Kuro sparatang",
  "item.minecraft.blade_pottery_shard": "Herus luleklignetel",
  "item.minecraft.blade_pottery_sherd": "Herus luleklignetel",
  "item.minecraft.blaze_powder": "Honodjinalk",
  "item.minecraft.blaze_rod": "Honodjinvjetka",
  "item.minecraft.blaze_spawn_egg": "Sintuajaitso f'Honodjin",
  "item.minecraft.blue_bundle": "Blau festakaban",
  "item.minecraft.blue_dye": "Blau faria",
  "item.minecraft.blue_egg": "Blau jaitso",
  "item.minecraft.blue_harness": "Blau sparatang",
  "item.minecraft.bogged_spawn_egg": "Sintuajaitso f'Boggeta",
  "item.minecraft.bolt_armor_trim_smithing_template": "Jerkatergo karta",
  "item.minecraft.bolt_armor_trim_smithing_template.new": "Strelena komuskefal",
  "item.minecraft.bone": "Pone",
  "item.minecraft.bone_meal": "Ponenen",
  "item.minecraft.book": "Libre",
  "item.minecraft.bordure_indented_banner_pattern": "Bideskrais mitt hammas ishuparjad fu flakka",
  "item.minecraft.bow": "Lunasen",
  "item.minecraft.bowl": "Staklingje",
  "item.minecraft.bread": "Pan",
  "item.minecraft.breeze_rod": "Luftsjal-vjetka",
  "item.minecraft.breeze_spawn_egg": "Sintuajaitso fu Luftsjal",
  "item.minecraft.brewer_pottery_shard": "Toreudjin luleklignetel",
  "item.minecraft.brewer_pottery_sherd": "Toreudjin luleklignetel",
  "item.minecraft.brewing_stand": "Ishketoreudwaibma",
  "item.minecraft.brick": "Gdent",
  "item.minecraft.brown_bundle": "Brun festakaban",
  "item.minecraft.brown_dye": "Kafe faria",
  "item.minecraft.brown_egg": "Kafe jaitso",
  "item.minecraft.brown_harness": "Kafe sparatang",
  "item.minecraft.brush": "Sikat",
  "item.minecraft.bucket": "Klingedai",
  "item.minecraft.bundle": "Festakaban",
  "item.minecraft.bundle.empty": "Ohare",
  "item.minecraft.bundle.empty.description": "Deki har viskena kaban fu ting",
  "item.minecraft.bundle.full": "Pulap",
  "item.minecraft.bundle.fullness": "%s/%s",
  "item.minecraft.burn_pottery_shard": "Hono luleklignetel",
  "item.minecraft.burn_pottery_sherd": "Hono luleklignetel",
  "item.minecraft.camel_husk_spawn_egg": "Sintuajaitso f'Utenshal Sangju",
  "item.minecraft.camel_spawn_egg": "Sintuajaitso f'Sangju",
  "item.minecraft.carrot": "Karoten",
  "item.minecraft.carrot_on_a_stick": "Vjetkakaroten",
  "item.minecraft.cat_spawn_egg": "Sintuajaitso f'Kot",
  "item.minecraft.cauldron": "Tofdai",
  "item.minecraft.cave_spider_spawn_egg": "Sintuajaitso f'Sirangakasjalka",
  "item.minecraft.chainmail_boots": "Jerkatul tøvel",
  "item.minecraft.chainmail_chestplate": "Jerkatul-shatsu",
  "item.minecraft.chainmail_helmet": "Jerkatul-pipo",
  "item.minecraft.chainmail_leggings": "Jerkatul jalakaklea",
  "item.minecraft.charcoal": "Baumkolme",
  "item.minecraft.cherry_boat": "Sakuracjip",
  "item.minecraft.cherry_chest_boat": "Sakuracjip mit baksu",
  "item.minecraft.chest_minecart": "Rofainen mit baksu",
  "item.minecraft.chicken": "Kuritsa utengotova",
  "item.minecraft.chicken_spawn_egg": "Sintuajaitso f'Kuritsa",
  "item.minecraft.chorus_fruit": "Sjansonfraut",
  "item.minecraft.clay_ball": "Glinashtof/Gdhendter",
  "item.minecraft.clock": "Toke",
  "item.minecraft.coal": "Kolme",
  "item.minecraft.coast_armor_trim_smithing_template": "Jerkatbaksu",
  "item.minecraft.coast_armor_trim_smithing_template.new": "Mare komuskefal",
  "item.minecraft.cocoa_beans": "Shokileing",
  "item.minecraft.cod": "Shirosakana utengotova",
  "item.minecraft.cod_bucket": "Badzhel fu shirosakana",
  "item.minecraft.cod_spawn_egg": "Sintuajaitso f'Shirosakana",
  "item.minecraft.command_block_minecart": "Rofainen mit jewaltdado",
  "item.minecraft.compass": "Dokobma",
  "item.minecraft.cooked_beef": "Kuhjnena gju",
  "item.minecraft.cooked_chicken": "Kuritsa kuhnjena",
  "item.minecraft.cooked_cod": "Kuhnena shirosakana",
  "item.minecraft.cooked_mutton": "Lammas kuhnjena",
  "item.minecraft.cooked_porkchop": "Svinja kuhnjena",
  "item.minecraft.cooked_rabbit": "Kuneli kuhnjena",
  "item.minecraft.cooked_salmon": "Kuhnena honosakana",
  "item.minecraft.cookie": "Kekso",
  "item.minecraft.copper_axe": "Kupkat jondu",
  "item.minecraft.copper_boots": "Kupkat tovel",
  "item.minecraft.copper_chestplate": "Kupkat eshkushatsu",
  "item.minecraft.copper_golem_spawn_egg": "Sintuajaitso f'Kupkatbotto",
  "item.minecraft.copper_helmet": "Kupkat pipo",
  "item.minecraft.copper_hoe": "Kupkat piegørmoi",
  "item.minecraft.copper_horse_armor": "Kupkat eshkuklea per hengest",
  "item.minecraft.copper_ingot": "Kupkat dadonen",
  "item.minecraft.copper_leggings": "Kupkat jalakaklea",
  "item.minecraft.copper_nautilus_armor": "Kupkat eshkuklea per beihjen",
  "item.minecraft.copper_nugget": "Kupkatnen",
  "item.minecraft.copper_pickaxe": "Kupkat puangørmoi",
  "item.minecraft.copper_shovel": "Kupkat toilara",
  "item.minecraft.copper_spear": "Kupkat streladai",
  "item.minecraft.copper_sword": "Kupkat herus",
  "item.minecraft.cow_spawn_egg": "Sintuajaitso f'Gju",
  "item.minecraft.creaking_spawn_egg": "Sintuajaitso f'Djidodjin",
  "item.minecraft.creeper_banner_pattern": "Ishuparjad fu flakka",
  "item.minecraft.creeper_banner_pattern.desc": "Creeper bumshtof",
  "item.minecraft.creeper_banner_pattern.new": "Creepernen ishuparjad fu flakka",
  "item.minecraft.creeper_spawn_egg": "Sintuajaitso f'Creeper",
  "item.minecraft.crossbow": "Ruzhjó",
  "item.minecraft.crossbow.projectile": "Na strela:",
  "item.minecraft.crossbow.projectile.multiple": "Strela: %s x %s",
  "item.minecraft.crossbow.projectile.single": "Strela: %s",
  "item.minecraft.cyan_bundle": "Culus festakaban",
  "item.minecraft.cyan_dye": "Tsulus faria",
  "item.minecraft.cyan_harness": "Tsulus sparatang",
  "item.minecraft.danger_pottery_shard": "Gris luleklignetel",
  "item.minecraft.danger_pottery_sherd": "Gris luleklignetel",
  "item.minecraft.dark_oak_boat": "Kurairus cjip",
  "item.minecraft.dark_oak_chest_boat": "Kurairus cjip mit baksu",
  "item.minecraft.debug_stick": "Zereforma vjetka",
  "item.minecraft.debug_stick.empty": "%s har nil impla",
  "item.minecraft.debug_stick.select": "sentakena \"%s\" (%s)",
  "item.minecraft.debug_stick.update": "\"%s\" kara %s made",
  "item.minecraft.diamond": "Helenapetra",
  "item.minecraft.diamond_axe": "Helenaishi jondu",
  "item.minecraft.diamond_boots": "Helenaishi-tøvel",
  "item.minecraft.diamond_chestplate": "Beishatsu na helenaishi",
  "item.minecraft.diamond_helmet": "Helenaishi beipipo",
  "item.minecraft.diamond_hoe": "Lantviskena helenaishi",
  "item.minecraft.diamond_horse_armor": "Helenaishi hengesteshkuklea",
  "item.minecraft.diamond_leggings": "Helenaishi-jalakaklea",
  "item.minecraft.diamond_nautilus_armor": "Helenaishi eshkuklea per beihjen",
  "item.minecraft.diamond_pickaxe": "Helenaishi gørmoi",
  "item.minecraft.diamond_shovel": "Helenaishi qoilara",
  "item.minecraft.diamond_spear": "Helenaishi streladai",
  "item.minecraft.diamond_sword": "Helenaishi herus",
  "item.minecraft.disc_fragment_5": "Tel fu musikkrais",
  "item.minecraft.disc_fragment_5.desc": "Musikkrais",
  "item.minecraft.dolphin_spawn_egg": "Sintuajaitso f'Maresvinja",
  "item.minecraft.donkey_spawn_egg": "Sintuajaitso f'Esel",
  "item.minecraft.dragon_breath": "Rjuhengi",
  "item.minecraft.dried_kelp": "Djotri marekaali",
  "item.minecraft.drowned_spawn_egg": "Sintuajaitso f'Eridaunjena",
  "item.minecraft.dune_armor_trim_smithing_template": "Jerkatbaksu",
  "item.minecraft.dune_armor_trim_smithing_template.new": "Sanberk komuskefal",
  "item.minecraft.echo_shard": "Raz-zam telnen",
  "item.minecraft.egg": "Jaitso",
  "item.minecraft.elder_guardian_spawn_egg": "Sintuajaitso f'Gammeljewaltdjin",
  "item.minecraft.elytra": "Tsubasa",
  "item.minecraft.emerald": "Zomorrod",
  "item.minecraft.enchanted_book": "Taikalibre",
  "item.minecraft.enchanted_golden_apple": "Taika geltringo",
  "item.minecraft.end_crystal": "Endpetra",
  "item.minecraft.ender_dragon_spawn_egg": "Sintuajaitso f'Enderrju",
  "item.minecraft.ender_eye": "Enderme",
  "item.minecraft.ender_pearl": "Endermjahnen",
  "item.minecraft.enderman_spawn_egg": "Sintuajaitso f'Enderdjin",
  "item.minecraft.endermite_spawn_egg": "Sintuajaitso f'Endermite",
  "item.minecraft.evoker_spawn_egg": "Sintuajaitso f'Taikantadjin",
  "item.minecraft.experience_bottle": "Taikaklinye",
  "item.minecraft.explorer_pottery_shard": "Sughadjin luleklignetel",
  "item.minecraft.explorer_pottery_sherd": "Sughadjin luleklignetel",
  "item.minecraft.eye_armor_trim_smithing_template": "Jerkatbaksu",
  "item.minecraft.eye_armor_trim_smithing_template.new": "Me komuskefal",
  "item.minecraft.feather": "Pjera",
  "item.minecraft.fermented_spider_eye": "Ereshku me fu kasiyalaka",
  "item.minecraft.field_masoned_banner_pattern": "Hina gdent ishuparjad fu flakka",
  "item.minecraft.filled_map": "Karta",
  "item.minecraft.fire_charge": "Honoozeus",
  "item.minecraft.firework_rocket": "Honomjachstrela",
  "item.minecraft.firework_rocket.flight": "Tidatai fu ljeta:",
  "item.minecraft.firework_rocket.multiple_stars": "%s x %s",
  "item.minecraft.firework_rocket.single_star": "%s",
  "item.minecraft.firework_star": "Bamzvezda",
  "item.minecraft.firework_star.black": "Kuro",
  "item.minecraft.firework_star.blue": "Blau",
  "item.minecraft.firework_star.brown": "Kafe",
  "item.minecraft.firework_star.custom_color": "Na smak",
  "item.minecraft.firework_star.cyan": "Tsulus",
  "item.minecraft.firework_star.fade_to": "Hiidas bli",
  "item.minecraft.firework_star.flicker": "Razkira",
  "item.minecraft.firework_star.gray": "Gris",
  "item.minecraft.firework_star.green": "Midori",
  "item.minecraft.firework_star.light_blue": "Sini",
  "item.minecraft.firework_star.light_gray": "Shirogris",
  "item.minecraft.firework_star.lime": "Shiromidori",
  "item.minecraft.firework_star.magenta": "Romura",
  "item.minecraft.firework_star.orange": "Portokali",
  "item.minecraft.firework_star.pink": "Roza",
  "item.minecraft.firework_star.purple": "Muranen",
  "item.minecraft.firework_star.red": "Ro",
  "item.minecraft.firework_star.shape": "Trelo fal",
  "item.minecraft.firework_star.shape.burst": "Zvezdabam",
  "item.minecraft.firework_star.shape.creeper": "Creeperfal",
  "item.minecraft.firework_star.shape.large_ball": "Stuur mjach",
  "item.minecraft.firework_star.shape.small_ball": "Cjisai mjacj",
  "item.minecraft.firework_star.shape.star": "Zvezdafal",
  "item.minecraft.firework_star.trail": "Naruganen",
  "item.minecraft.firework_star.white": "Shiro",
  "item.minecraft.firework_star.yellow": "Kiiro",
  "item.minecraft.fishing_rod": "Sakanavjetka",
  "item.minecraft.flint": "Honohadji",
  "item.minecraft.flint_and_steel": "Honoishi mit jerkat",
  "item.minecraft.flow_armor_trim_smithing_template": "Jerkatergo karta",
  "item.minecraft.flow_armor_trim_smithing_template.new": "Virta komuskefal",
  "item.minecraft.flow_banner_pattern": "Ishuparjad fu flakka",
  "item.minecraft.flow_banner_pattern.desc": "Virta",
  "item.minecraft.flow_banner_pattern.new": "Virta ishuparjad fu flakka",
  "item.minecraft.flow_pottery_sherd": "Luleklignetel",
  "item.minecraft.flower_banner_pattern": "Ishuparjad fu flakka",
  "item.minecraft.flower_banner_pattern.desc": "Luleriso",
  "item.minecraft.flower_banner_pattern.new": "Lulenen ishuparjad fu flakka",
  "item.minecraft.flower_pot": "Luleklinje",
  "item.minecraft.fox_spawn_egg": "Sintuajaitso f'Kitsune",
  "item.minecraft.friend_pottery_shard": "Mik luleklignetel",
  "item.minecraft.friend_pottery_sherd": "Mik luleklignetel",
  "item.minecraft.frog_spawn_egg": "Sintuajaitso f'Baba",
  "item.minecraft.furnace_minecart": "Rofainen mit honobet",
  "item.minecraft.ghast_spawn_egg": "Sintuajaitso f'Ghast",
  "item.minecraft.ghast_tear": "Nakutel f'Ghast",
  "item.minecraft.glass_bottle": "Glasbadjeil",
  "item.minecraft.glistering_melon_slice": "Razkirkas ishkefrauttel",
  "item.minecraft.globe_banner_pattern": "Ishuparjad fu flakka",
  "item.minecraft.globe_banner_pattern.desc": "Veltmjacj",
  "item.minecraft.globe_banner_pattern.new": "Veltmjacj ishuparjad fu flakka",
  "item.minecraft.glow_berries": "Kirkasfrautnen",
  "item.minecraft.glow_ink_sac": "Kiragira fargekaban",
  "item.minecraft.glow_item_frame": "Kiragira ekràn",
  "item.minecraft.glow_squid_spawn_egg": "Sintwajaitso f'Kiragira majakahjen",
  "item.minecraft.glowstone_dust": "Kirkassan",
  "item.minecraft.goat_horn": "Œchkenor",
  "item.minecraft.goat_spawn_egg": "Sintuajaitso f'øchke",
  "item.minecraft.gold_ingot": "Geltdadonen",
  "item.minecraft.gold_nugget": "Geltnen",
  "item.minecraft.golden_apple": "Geltringo",
  "item.minecraft.golden_axe": "Kelt jondu",
  "item.minecraft.golden_boots": "Gelttøvel",
  "item.minecraft.golden_carrot": "Geltkaroten",
  "item.minecraft.golden_chestplate": "Gelt beishatsu",
  "item.minecraft.golden_helmet": "Gelt beipipo",
  "item.minecraft.golden_hoe": "Kelt piegørmoi",
  "item.minecraft.golden_horse_armor": "Kelt eshkuklea per hengest",
  "item.minecraft.golden_leggings": "Gelt-jalakaklea",
  "item.minecraft.golden_nautilus_armor": "Geltkat eshkuklea per beihjen",
  "item.minecraft.golden_pickaxe": "Kelt puangørmoi",
  "item.minecraft.golden_shovel": "Keltqoilara",
  "item.minecraft.golden_spear": "Gelt streladai",
  "item.minecraft.golden_sword": "Keltherus",
  "item.minecraft.gray_bundle": "Gris festakaban",
  "item.minecraft.gray_dye": "Gris faria",
  "item.minecraft.gray_harness": "Gris sparatang",
  "item.minecraft.green_bundle": "Midori festakaban",
  "item.minecraft.green_dye": "Midori faria",
  "item.minecraft.green_harness": "Midori sparatang",
  "item.minecraft.guardian_spawn_egg": "Sintuajaitso f'zihadjin",
  "item.minecraft.gunpowder": "Bamsokeri",
  "item.minecraft.guster_banner_pattern": "Ishuparjad fu flakka",
  "item.minecraft.guster_banner_pattern.desc": "Luftnen",
  "item.minecraft.guster_banner_pattern.new": "Luftnen Ishuparjad fu flakka",
  "item.minecraft.guster_pottery_sherd": "Luftnen klignetel",
  "item.minecraft.happy_ghast_spawn_egg": "Sintuajaitso f'Ghastle",
  "item.minecraft.harness": "Sparatang",
  "item.minecraft.heart_of_the_sea": "Ker fu mare",
  "item.minecraft.heart_pottery_shard": "Ker luleklignetel",
  "item.minecraft.heart_pottery_sherd": "Ker luleklignetel",
  "item.minecraft.heartbreak_pottery_shard": "Kershinu luleklignetel",
  "item.minecraft.heartbreak_pottery_sherd": "Kershinu luleklignetel",
  "item.minecraft.hoglin_spawn_egg": "Sintuajaitso f'Hoglin",
  "item.minecraft.honey_bottle": "Mjaltbadjel",
  "item.minecraft.honeycomb": "Mjalttumam",
  "item.minecraft.hopper_minecart": "Rofainen mit sadantating",
  "item.minecraft.horse_spawn_egg": "Sintuajaitso f'Hengest",
  "item.minecraft.host_armor_trim_smithing_template": "Jerkatbaksu",
  "item.minecraft.host_armor_trim_smithing_template.new": "Vomi komuskefal",
  "item.minecraft.howl_pottery_shard": "Awuu luleklignetel",
  "item.minecraft.howl_pottery_sherd": "Awuu luleklignetel",
  "item.minecraft.husk_spawn_egg": "Sintuajaitso f'Utenshal",
  "item.minecraft.ink_sac": "Kurokabang",
  "item.minecraft.iron_axe": "Jerkat jondu",
  "item.minecraft.iron_boots": "Jerkat tøvel",
  "item.minecraft.iron_chestplate": "Jerkat eshkushatsu",
  "item.minecraft.iron_golem_spawn_egg": "Sintuajaitso f'Jerkatrobotto",
  "item.minecraft.iron_helmet": "Jerkat pipo",
  "item.minecraft.iron_hoe": "Jerkat piegørmoi",
  "item.minecraft.iron_horse_armor": "Jerkat eshkuklea per hengest",
  "item.minecraft.iron_ingot": "Jerkatdadonen",
  "item.minecraft.iron_leggings": "Jerkat jalakaklea",
  "item.minecraft.iron_nautilus_armor": "Jerkat eshkuklea per beihjen",
  "item.minecraft.iron_nugget": "Jerkatnen",
  "item.minecraft.iron_pickaxe": "Jerkat puangørmoi",
  "item.minecraft.iron_shovel": "Jerkatoilara",
  "item.minecraft.iron_spear": "Jerkat streladai",
  "item.minecraft.iron_sword": "Jerkatherus",
  "item.minecraft.item_frame": "Ekràn",
  "item.minecraft.jungle_boat": "Pluidasos cjip",
  "item.minecraft.jungle_chest_boat": "Pluidasos cjip mit baksu",
  "item.minecraft.knowledge_book": "Shirulibre",
  "item.minecraft.lapis_lazuli": "Blaushtof",
  "item.minecraft.lava_bucket": "Badzhel fu jhotishke",
  "item.minecraft.lead": "Gutsjonuito",
  "item.minecraft.leather": "Gjukodja",
  "item.minecraft.leather_boots": "Gjukodjatøvel",
  "item.minecraft.leather_chestplate": "Gjukodjashatsu",
  "item.minecraft.leather_helmet": "Gjukodjapipo",
  "item.minecraft.leather_horse_armor": "Gjukodja eshkuklea per hengest",
  "item.minecraft.leather_leggings": "Gjukodja jalakaklea",
  "item.minecraft.light_blue_bundle": "Sini festakaban",
  "item.minecraft.light_blue_dye": "Sini faria",
  "item.minecraft.light_blue_harness": "Sini sparatang",
  "item.minecraft.light_gray_bundle": "Shirogris festakaban",
  "item.minecraft.light_gray_dye": "Shirogris faria",
  "item.minecraft.light_gray_harness": "Shirogris sparatang",
  "item.minecraft.lime_bundle": "Shiromidori festakaban",
  "item.minecraft.lime_dye": "Shiromidori faria",
  "item.minecraft.lime_harness": "Shiromidori sparatang",
  "item.minecraft.lingering_potion": "Polbamiskje",
  "item.minecraft.lingering_potion.effect.awkward": "Polbamishke trelo",
  "item.minecraft.lingering_potion.effect.empty": "Polbamiskje kafan",
  "item.minecraft.lingering_potion.effect.fire_resistance": "Polbamiskje honoziha",
  "item.minecraft.lingering_potion.effect.harming": "Polbamiskje arka",
  "item.minecraft.lingering_potion.effect.healing": "Polbamiskje reforma",
  "item.minecraft.lingering_potion.effect.infested": "Polbamiskje fu flan",
  "item.minecraft.lingering_potion.effect.invisibility": "Polbamiskje senajena",
  "item.minecraft.lingering_potion.effect.leaping": "Polbamiskje per paldai",
  "item.minecraft.lingering_potion.effect.levitation": "Polbamiskje per ljeta",
  "item.minecraft.lingering_potion.effect.luck": "Polbamiskje per braudacji",
  "item.minecraft.lingering_potion.effect.mundane": "Polbamishke tsumaranai",
  "item.minecraft.lingering_potion.effect.night_vision": "Polbamiskje per nahtse",
  "item.minecraft.lingering_potion.effect.oozing": "Polbamiskje per umokri",
  "item.minecraft.lingering_potion.effect.poison": "Polbamiskje per tuin",
  "item.minecraft.lingering_potion.effect.regeneration": "Polbamiskje per zdorvabli",
  "item.minecraft.lingering_potion.effect.slow_falling": "Polbamiskje per hiidasspada",
  "item.minecraft.lingering_potion.effect.slowness": "Polbamiskje per hiidas",
  "item.minecraft.lingering_potion.effect.strength": "Polbamiskje per djong",
  "item.minecraft.lingering_potion.effect.swiftness": "Polbamiskje per bystrazma",
  "item.minecraft.lingering_potion.effect.thick": "Polbamishke mjaltlik",
  "item.minecraft.lingering_potion.effect.turtle_master": "Polbamiskje fu breshkamestari",
  "item.minecraft.lingering_potion.effect.water": "Polbamiskje",
  "item.minecraft.lingering_potion.effect.water_breathing": "Polbamiskje per ishkehengi",
  "item.minecraft.lingering_potion.effect.weakness": "Polbamiskje per shvants",
  "item.minecraft.lingering_potion.effect.weaving": "Polbamiskje per raznuito",
  "item.minecraft.lingering_potion.effect.wind_charged": "Polbamiskje per luftzeus",
  "item.minecraft.llama_spawn_egg": "Sintuajaitso f'Lama",
  "item.minecraft.lodestone_compass": "Dokotoke per plasdado",
  "item.minecraft.mace": "Bulavá",
  "item.minecraft.magenta_bundle": "Romura festakaban",
  "item.minecraft.magenta_dye": "Romura faria",
  "item.minecraft.magenta_harness": "Romura sparatang",
  "item.minecraft.magma_cream": "Zjotnjuu",
  "item.minecraft.magma_cube_spawn_egg": "Sintuajaitso f'Zjotsewas",
  "item.minecraft.mangrove_boat": "Mangrcjip",
  "item.minecraft.mangrove_chest_boat": "Mangrchjip mit baksu",
  "item.minecraft.map": "Ohare karta",
  "item.minecraft.melon_seeds": "Ishkefrautpie",
  "item.minecraft.melon_slice": "Ishkefrauttel",
  "item.minecraft.milk_bucket": "Badjel fu nyu",
  "item.minecraft.minecart": "Rofai",
  "item.minecraft.miner_pottery_shard": "Shahtadjin luleklignetel",
  "item.minecraft.miner_pottery_sherd": "Shahtadjin luleklignetel",
  "item.minecraft.mojang_banner_pattern": "Ishuparjad fu flakka",
  "item.minecraft.mojang_banner_pattern.desc": "Ting",
  "item.minecraft.mojang_banner_pattern.new": "Ting ishuparjad fu flakka",
  "item.minecraft.mooshroom_spawn_egg": "Sintuajaitso f'Mooshroom",
  "item.minecraft.mourner_pottery_shard": "Nakudjin luleklignetel",
  "item.minecraft.mourner_pottery_sherd": "Nakudjin luleklignetel",
  "item.minecraft.mule_spawn_egg": "Sintuajaitso f'Hengesel",
  "item.minecraft.mushroom_stew": "Manitarista",
  "item.minecraft.music_disc_11": "Liidkrais",
  "item.minecraft.music_disc_11.desc": "C418 - 11",
  "item.minecraft.music_disc_13": "Lidkrais",
  "item.minecraft.music_disc_13.desc": "C418 - 13",
  "item.minecraft.music_disc_5": "Lidkrais",
  "item.minecraft.music_disc_5.desc": "Samuel Åberg - 5",
  "item.minecraft.music_disc_blocks": "Lidkrais",
  "item.minecraft.music_disc_blocks.desc": "C418 - dadora",
  "item.minecraft.music_disc_cat": "Lidkrais",
  "item.minecraft.music_disc_cat.desc": "C418 - kot",
  "item.minecraft.music_disc_chirp": "Lidkrais",
  "item.minecraft.music_disc_chirp.desc": "C418 - chiiip",
  "item.minecraft.music_disc_creator": "Lidkrais",
  "item.minecraft.music_disc_creator.desc": "Lena Raine - Creator",
  "item.minecraft.music_disc_creator_music_box": "Lena Raine - Creator",
  "item.minecraft.music_disc_creator_music_box.desc": "Lena Raine - Creator (Liidbaksu)",
  "item.minecraft.music_disc_far": "Lidkrais",
  "item.minecraft.music_disc_far.desc": "C418 - prapa",
  "item.minecraft.music_disc_lava_chicken": "Lidkrais",
  "item.minecraft.music_disc_lava_chicken.desc": "Hyper Potions - Lava Chicken",
  "item.minecraft.music_disc_mall": "Lidkrais",
  "item.minecraft.music_disc_mall.desc": "C418 - kaupapolisnen",
  "item.minecraft.music_disc_mellohi": "Lidkrais",
  "item.minecraft.music_disc_mellohi.desc": "C418 - mellohi",
  "item.minecraft.music_disc_otherside": "Lidkrais",
  "item.minecraft.music_disc_otherside.desc": "Lena Raine - andrtel",
  "item.minecraft.music_disc_pigstep": "Muzikkrais",
  "item.minecraft.music_disc_pigstep.desc": "Lena Raine - Svinjaleo",
  "item.minecraft.music_disc_precipice": "Lidkrais",
  "item.minecraft.music_disc_precipice.desc": "Aaron Cherof - Precipice",
  "item.minecraft.music_disc_relic": "Lidkrais",
  "item.minecraft.music_disc_relic.desc": "Aaron Cherof - Relic",
  "item.minecraft.music_disc_stal": "Lidkrais",
  "item.minecraft.music_disc_stal.desc": "C418 - stal",
  "item.minecraft.music_disc_strad": "Lidkrais",
  "item.minecraft.music_disc_strad.desc": "C418 - strad",
  "item.minecraft.music_disc_tears": "Lidkrais",
  "item.minecraft.music_disc_tears.desc": "Amos Roddy - Tears",
  "item.minecraft.music_disc_wait": "Muzikkrais",
  "item.minecraft.music_disc_wait.desc": "C418 - vent",
  "item.minecraft.music_disc_ward": "Lidkrais",
  "item.minecraft.music_disc_ward.desc": "C418 - ward",
  "item.minecraft.mutton": "Lammas utengotova",
  "item.minecraft.name_tag": "Namaenen",
  "item.minecraft.nautilus_shell": "Komuske fu Beihjen",
  "item.minecraft.nautilus_spawn_egg": "Sintuajaitso f'Beihjen",
  "item.minecraft.nether_brick": "Nether gdent",
  "item.minecraft.nether_star": "Nethersfezda",
  "item.minecraft.nether_wart": "Netherlule",
  "item.minecraft.netherite_axe": "Nethershtof jondu",
  "item.minecraft.netherite_boots": "Netherit tøvel",
  "item.minecraft.netherite_chestplate": "Netherit eshkushatsu",
  "item.minecraft.netherite_helmet": "Netherit pipo",
  "item.minecraft.netherite_hoe": "Netherit piegørmoi",
  "item.minecraft.netherite_horse_armor": "Netherstof eshkuklea per hengest",
  "item.minecraft.netherite_ingot": "Netherit dadonen",
  "item.minecraft.netherite_leggings": "Netherit jalakaklea",
  "item.minecraft.netherite_nautilus_armor": "Netherstof eshkuklea per beihjen",
  "item.minecraft.netherite_pickaxe": "Nethershtof puangørmoi",
  "item.minecraft.netherite_scrap": "Netherit myl",
  "item.minecraft.netherite_shovel": "Netherit qoilara",
  "item.minecraft.netherite_spear": "Netherstof streladai",
  "item.minecraft.netherite_sword": "Nethershtof herus",
  "item.minecraft.netherite_upgrade_smithing_template": "Jerkatbaksu",
  "item.minecraft.netherite_upgrade_smithing_template.new": "Netherit plusbrøzana",
  "item.minecraft.oak_boat": "Ruscjip",
  "item.minecraft.oak_chest_boat": "Ruscjip mit baksu",
  "item.minecraft.ocelot_spawn_egg": "Sintuajaitso f'Baumkot",
  "item.minecraft.ominous_bottle": "Badjel fu nafakoro",
  "item.minecraft.ominous_trial_key": "Iskatdaiklucj fu nafakoro",
  "item.minecraft.orange_bundle": "Portokali festakaban",
  "item.minecraft.orange_dye": "Portokali faria",
  "item.minecraft.orange_harness": "Portokali sparatang",
  "item.minecraft.painting": "Riso",
  "item.minecraft.pale_oak_boat": "Shirorus-sjip",
  "item.minecraft.pale_oak_chest_boat": "Shirorus-sjip mit baksu",
  "item.minecraft.panda_spawn_egg": "Sintuajaitso f'Pantaa",
  "item.minecraft.paper": "Paperi",
  "item.minecraft.parched_spawn_egg": "Sintuajaitso f'Erdjotridjin",
  "item.minecraft.parrot_spawn_egg": "Sintuajaitso f'Hanufogel",
  "item.minecraft.phantom_membrane": "Godzha f'On",
  "item.minecraft.phantom_spawn_egg": "Sintuajaitso f'On",
  "item.minecraft.pig_spawn_egg": "Sintuajaitso f'Sfinja",
  "item.minecraft.piglin_banner_pattern": "Ishuparjad fu flakka",
  "item.minecraft.piglin_banner_pattern.desc": "Hana",
  "item.minecraft.piglin_banner_pattern.new": "Hana ishuparjad fu flakka",
  "item.minecraft.piglin_brute_spawn_egg": "Sintuajaitso f'Djongpiglin",
  "item.minecraft.piglin_spawn_egg": "Sintuajaitso f'Piglin",
  "item.minecraft.pillager_spawn_egg": "Sintuajaitso f'Poliskrigdjin",
  "item.minecraft.pink_bundle": "Roza festakaban",
  "item.minecraft.pink_dye": "Roza faria",
  "item.minecraft.pink_harness": "Roza sparatang",
  "item.minecraft.pitcher_plant": "Klingjeruti",
  "item.minecraft.pitcher_pod": "Piekaban fu klingjeruti",
  "item.minecraft.plenty_pottery_shard": "Lagom luleklignetel",
  "item.minecraft.plenty_pottery_sherd": "Lagom luleklignetel",
  "item.minecraft.poisonous_potato": "Tuinkartofel",
  "item.minecraft.polar_bear_spawn_egg": "Sintuajaitso f'Upashkarhu",
  "item.minecraft.popped_chorus_fruit": "Sjansonfraut bamjena",
  "item.minecraft.porkchop": "Svinja utengotova",
  "item.minecraft.potato": "Kartofel",
  "item.minecraft.potion": "Taikaiskje",
  "item.minecraft.potion.effect.awkward": "Taikaishke trelo",
  "item.minecraft.potion.effect.empty": "Taikaishke kafan",
  "item.minecraft.potion.effect.fire_resistance": "Taikaiskje honoziha",
  "item.minecraft.potion.effect.harming": "Taikaiskje arka",
  "item.minecraft.potion.effect.healing": "Taikaiskje reforma",
  "item.minecraft.potion.effect.infested": "Taikaiskje fu flan",
  "item.minecraft.potion.effect.invisibility": "Taikaiskje senajena",
  "item.minecraft.potion.effect.leaping": "Taikaiskje paldai",
  "item.minecraft.potion.effect.levitation": "Taikaiskje ljeta",
  "item.minecraft.potion.effect.luck": "Taikaiskje braudacji",
  "item.minecraft.potion.effect.mundane": "Taikaishke tsumaranai",
  "item.minecraft.potion.effect.night_vision": "Taikaiskje nahtse",
  "item.minecraft.potion.effect.oozing": "Taikaiskje fu umokrizma",
  "item.minecraft.potion.effect.poison": "Taikaiskje tuin",
  "item.minecraft.potion.effect.regeneration": "Taikaiskje gjenzdorva",
  "item.minecraft.potion.effect.slow_falling": "Taikaiskje ljetaspada",
  "item.minecraft.potion.effect.slowness": "Taikaiskje hidas",
  "item.minecraft.potion.effect.strength": "Taikaiskje djon",
  "item.minecraft.potion.effect.swiftness": "Taikaiskje bistra",
  "item.minecraft.potion.effect.thick": "Taikaishke festadai",
  "item.minecraft.potion.effect.turtle_master": "Taikaiskje grenzajewalt",
  "item.minecraft.potion.effect.water": "Iskjeklinje",
  "item.minecraft.potion.effect.water_breathing": "Taikaiskje iskjeluft",
  "item.minecraft.potion.effect.weakness": "Taikaiskje sfjanc",
  "item.minecraft.potion.effect.weaving": "Taikaiskje fu raznuito",
  "item.minecraft.potion.effect.wind_charged": "Taikaiskje fu luftzeus",
  "item.minecraft.pottery_shard_archer": "Lunadjin luleklignetel",
  "item.minecraft.pottery_shard_arms_up": "Hantiwai luleklignetel",
  "item.minecraft.pottery_shard_prize": "Jingbaksu luleklignetel",
  "item.minecraft.pottery_shard_skull": "Poneatama luleklignetel",
  "item.minecraft.powder_snow_bucket": "Badzhel fu alk upash",
  "item.minecraft.prismarine_crystals": "Prizmarin glasishi",
  "item.minecraft.prismarine_shard": "Prizmarin telnen",
  "item.minecraft.prize_pottery_shard": "Jingbaksu luleklignetel",
  "item.minecraft.prize_pottery_sherd": "Jingbaksu luleklignetel",
  "item.minecraft.pufferfish": "Porupnesakana",
  "item.minecraft.pufferfish_bucket": "Badjel mitt rupnesakana",
  "item.minecraft.pufferfish_spawn_egg": "Sintuajaitso f'Rupnesakana",
  "item.minecraft.pumpkin_pie": "Achorfrauttorta",
  "item.minecraft.pumpkin_seeds": "Achorfrautpie",
  "item.minecraft.purple_bundle": "Murasaki festakaban",
  "item.minecraft.purple_dye": "Muranen faria",
  "item.minecraft.purple_harness": "Muranen sparatang",
  "item.minecraft.quartz": "Nether kacha",
  "item.minecraft.rabbit": "Kuneli utengotova",
  "item.minecraft.rabbit_foot": "Kunelijalakanen",
  "item.minecraft.rabbit_hide": "Kunelikodja",
  "item.minecraft.rabbit_spawn_egg": "Sintuajaitso f'Kuneli",
  "item.minecraft.rabbit_stew": "Kunelista",
  "item.minecraft.raiser_armor_trim_smithing_template": "Jerkatbaksu",
  "item.minecraft.raiser_armor_trim_smithing_template.new": "Avara komuskefal",
  "item.minecraft.ravager_spawn_egg": "Sintuajaitso f'Erviskenadjin",
  "item.minecraft.raw_copper": "Yttengotova kupkat",
  "item.minecraft.raw_gold": "Kelt uten gotova",
  "item.minecraft.raw_iron": "Yttengotova jerkat",
  "item.minecraft.recovery_compass": "Shinu-dokobma",
  "item.minecraft.red_bundle": "Ros festakaban",
  "item.minecraft.red_dye": "Ro faria",
  "item.minecraft.red_harness": "Ro sparatang",
  "item.minecraft.redstone": "Redstone",
  "item.minecraft.resin_brick": "Mjaltpetra gdjent",
  "item.minecraft.resin_clump": "Mjaltpetramjah",
  "item.minecraft.rib_armor_trim_smithing_template": "Jerkatbaksu",
  "item.minecraft.rib_armor_trim_smithing_template.new": "Baksupone komuskefal",
  "item.minecraft.rotten_flesh": "Flanshøt",
  "item.minecraft.saddle": "Hengestisu",
  "item.minecraft.salmon": "Honosakana utengotova",
  "item.minecraft.salmon_bucket": "Badzhel fu honosakana",
  "item.minecraft.salmon_spawn_egg": "Sintuajaitso f'Honoosakana",
  "item.minecraft.scrape_pottery_sherd": "Aischo luleklignetel",
  "item.minecraft.scute": "Komuskepone",
  "item.minecraft.sentry_armor_trim_smithing_template": "Jerkatbaksu",
  "item.minecraft.sentry_armor_trim_smithing_template.new": "Sedjin komuskefal",
  "item.minecraft.shaper_armor_trim_smithing_template": "Jerkatbaksu",
  "item.minecraft.shaper_armor_trim_smithing_template.new": "Mahdjin komuskefal",
  "item.minecraft.sheaf_pottery_shard": "Baumnen luleklignetel",
  "item.minecraft.sheaf_pottery_sherd": "Baumnen luleklignetel",
  "item.minecraft.shears": "Tsambliznets",
  "item.minecraft.sheep_spawn_egg": "Sintuajaitso f'Lammas",
  "item.minecraft.shelter_pottery_shard": "Vomi luleklignetel",
  "item.minecraft.shelter_pottery_sherd": "Vomi luleklignetel",
  "item.minecraft.shield": "Komuske",
  "item.minecraft.shield.black": "Kuro komuske",
  "item.minecraft.shield.blue": "Blau komuske",
  "item.minecraft.shield.brown": "Kafe komuske",
  "item.minecraft.shield.cyan": "Tsulus komuske",
  "item.minecraft.shield.gray": "Gris komuske",
  "item.minecraft.shield.green": "Midori komuske",
  "item.minecraft.shield.light_blue": "Sini komuske",
  "item.minecraft.shield.light_gray": "Shirogris komuske",
  "item.minecraft.shield.lime": "Shiromidori komuske",
  "item.minecraft.shield.magenta": "Romura komuske",
  "item.minecraft.shield.orange": "Portokali komuske",
  "item.minecraft.shield.pink": "Roza komuske",
  "item.minecraft.shield.purple": "Muranen komuske",
  "item.minecraft.shield.red": "Ro komuske",
  "item.minecraft.shield.white": "Shiro komuske",
  "item.minecraft.shield.yellow": "Kiiro komuske",
  "item.minecraft.shulker_shell": "Shulkergodja",
  "item.minecraft.shulker_spawn_egg": "Sintuajaitso f'Shulker",
  "item.minecraft.sign": "Kotumam",
  "item.minecraft.silence_armor_trim_smithing_template": "Jerkatbaksu",
  "item.minecraft.silence_armor_trim_smithing_template.new": "Pinuno komuskefal",
  "item.minecraft.silverfish_spawn_egg": "Sintuajaitso f'Sokeribage",
  "item.minecraft.skeleton_horse_spawn_egg": "Sintuajaitso f'Ponehengest",
  "item.minecraft.skeleton_spawn_egg": "Sintuajaitso f'Ponedjin",
  "item.minecraft.skull_banner_pattern": "Ishuparjad fu flakka",
  "item.minecraft.skull_banner_pattern.desc": "Poneatama bumshtof",
  "item.minecraft.skull_banner_pattern.new": "Poneatama ishuparjad fu flakka",
  "item.minecraft.skull_pottery_shard": "Poneatama luleklignetel",
  "item.minecraft.skull_pottery_sherd": "Poneatama luleklignetel",
  "item.minecraft.slime_ball": "Gymi mjah",
  "item.minecraft.slime_spawn_egg": "Sintuajaitso f'Gymi",
  "item.minecraft.smithing_template": "Jerkatbaksu",
  "item.minecraft.smithing_template.applies_to": "Jam na:",
  "item.minecraft.smithing_template.armor_trim.additions_slot_description": "Nasi dadonen os petra",
  "item.minecraft.smithing_template.armor_trim.applies_to": "Eshkuklea",
  "item.minecraft.smithing_template.armor_trim.base_slot_description": "Nasii komusketel",
  "item.minecraft.smithing_template.armor_trim.ingredients": "Dadonen au petra",
  "item.minecraft.smithing_template.ingredients": "Trengena:",
  "item.minecraft.smithing_template.netherite_upgrade.additions_slot_description": "Nasi Netherit Dadonen",
  "item.minecraft.smithing_template.netherite_upgrade.applies_to": "Helenaishi eshkuting",
  "item.minecraft.smithing_template.netherite_upgrade.base_slot_description": "Nasii komusketel os kriigbruk os brukting ka na helenishifal",
  "item.minecraft.smithing_template.netherite_upgrade.ingredients": "Dadonen fu Netherit",
  "item.minecraft.smithing_template.upgrade": "Plusbrøze: ",
  "item.minecraft.sniffer_spawn_egg": "Sintuajaitso f'Nioidjin",
  "item.minecraft.snort_pottery_shard": "Hana luleklignetel",
  "item.minecraft.snort_pottery_sherd": "Hana luleklignetel",
  "item.minecraft.snout_armor_trim_smithing_template": "Jerkatbaksu",
  "item.minecraft.snout_armor_trim_smithing_template.new": "Hana komuskefal",
  "item.minecraft.snow_golem_spawn_egg": "Sintuajaitso f'Upashun",
  "item.minecraft.snowball": "Upasmjacj",
  "item.minecraft.spectral_arrow": "Asopstrela",
  "item.minecraft.spider_eye": "Kasjalkame",
  "item.minecraft.spider_spawn_egg": "Sintuajaitso f'Kasjalaka",
  "item.minecraft.spire_armor_trim_smithing_template": "Jerkatbaksu",
  "item.minecraft.spire_armor_trim_smithing_template.new": "Berkpik komuskefal",
  "item.minecraft.splash_potion": "Bamiskje",
  "item.minecraft.splash_potion.effect.awkward": "Bamishke trelo",
  "item.minecraft.splash_potion.effect.empty": "Bamiskje kafan",
  "item.minecraft.splash_potion.effect.fire_resistance": "Bamiskje honoziha",
  "item.minecraft.splash_potion.effect.harming": "Bamiskje arka",
  "item.minecraft.splash_potion.effect.healing": "Bamiskje reforma",
  "item.minecraft.splash_potion.effect.infested": "Flan-bamiskje",
  "item.minecraft.splash_potion.effect.invisibility": "Bamiskje senajena",
  "item.minecraft.splash_potion.effect.leaping": "Bamiskje paldai",
  "item.minecraft.splash_potion.effect.levitation": "Bamiskje ljeta",
  "item.minecraft.splash_potion.effect.luck": "Bamiskje braudacji",
  "item.minecraft.splash_potion.effect.mundane": "Bamishke tsumaranai",
  "item.minecraft.splash_potion.effect.night_vision": "Bamiskje nahtse",
  "item.minecraft.splash_potion.effect.oozing": "Umokri-bamiskje",
  "item.minecraft.splash_potion.effect.poison": "Bamiskje tuin",
  "item.minecraft.splash_potion.effect.regeneration": "Bamiskje gjenzdorva",
  "item.minecraft.splash_potion.effect.slow_falling": "Bamiskje ljetaspada",
  "item.minecraft.splash_potion.effect.slowness": "Bamiskje hidas",
  "item.minecraft.splash_potion.effect.strength": "Bamiskje djon",
  "item.minecraft.splash_potion.effect.swiftness": "Bamiskje bistra",
  "item.minecraft.splash_potion.effect.thick": "Bamishke festadai",
  "item.minecraft.splash_potion.effect.turtle_master": "Bamiskje grenzajewalt",
  "item.minecraft.splash_potion.effect.water": "Bamiskje",
  "item.minecraft.splash_potion.effect.water_breathing": "Bamiskje iskjeluft",
  "item.minecraft.splash_potion.effect.weakness": "Bamiskje sfjanc",
  "item.minecraft.splash_potion.effect.weaving": "Rjetnafa-bamiskje",
  "item.minecraft.splash_potion.effect.wind_charged": "Bamiskje fu luftpulap",
  "item.minecraft.spruce_boat": "Julcjip",
  "item.minecraft.spruce_chest_boat": "Julcjip mit baksu",
  "item.minecraft.spyglass": "Prapaseting",
  "item.minecraft.squid_spawn_egg": "Sintuajaitso f'Majakahjen",
  "item.minecraft.stick": "Vjetka",
  "item.minecraft.stone_axe": "Ishi jondu",
  "item.minecraft.stone_hoe": "Ishi piegørmoi",
  "item.minecraft.stone_pickaxe": "Ishi puangørmoi",
  "item.minecraft.stone_shovel": "Ishi qoilara",
  "item.minecraft.stone_spear": "Ishi streladai",
  "item.minecraft.stone_sword": "Itji herus",
  "item.minecraft.stray_spawn_egg": "Sintuajaitso f'Milupone",
  "item.minecraft.strider_spawn_egg": "Sintuajeitso fu Jalakadjin",
  "item.minecraft.string": "Nuito",
  "item.minecraft.sugar": "Sokkeri",
  "item.minecraft.suspicious_stew": "Sussta",
  "item.minecraft.sweet_berries": "Søt frautnen",
  "item.minecraft.tadpole_bucket": "Badzhel fu jirinos",
  "item.minecraft.tadpole_spawn_egg": "Sintuajaitso f'Jirinos",
  "item.minecraft.tide_armor_trim_smithing_template": "Jerkatbaksu",
  "item.minecraft.tide_armor_trim_smithing_template.new": "Hav komuskefal",
  "item.minecraft.tipped_arrow": "Taikastrela",
  "item.minecraft.tipped_arrow.effect.awkward": "Strela mitt taikashtof",
  "item.minecraft.tipped_arrow.effect.empty": "Strela fu kafan",
  "item.minecraft.tipped_arrow.effect.fire_resistance": "Strela fu honokømuske",
  "item.minecraft.tipped_arrow.effect.harming": "Strela fu arka",
  "item.minecraft.tipped_arrow.effect.healing": "Strela fu reforma",
  "item.minecraft.tipped_arrow.effect.infested": "Strela fu flan",
  "item.minecraft.tipped_arrow.effect.invisibility": "Strela fu unsejenadeki",
  "item.minecraft.tipped_arrow.effect.leaping": "Strela fu paldai",
  "item.minecraft.tipped_arrow.effect.levitation": "Strela fu ljeta",
  "item.minecraft.tipped_arrow.effect.luck": "Strela fu braudachi",
  "item.minecraft.tipped_arrow.effect.mundane": "Strela mitt taikashtof",
  "item.minecraft.tipped_arrow.effect.night_vision": "Strela fu nahtsedeki",
  "item.minecraft.tipped_arrow.effect.oozing": "Strela fu umokri",
  "item.minecraft.tipped_arrow.effect.poison": "Strela fu tuin",
  "item.minecraft.tipped_arrow.effect.regeneration": "Strela fu gjenzdorva",
  "item.minecraft.tipped_arrow.effect.slow_falling": "Strela fu hidasspada",
  "item.minecraft.tipped_arrow.effect.slowness": "Strela fu hidas",
  "item.minecraft.tipped_arrow.effect.strength": "Strela fu djong",
  "item.minecraft.tipped_arrow.effect.swiftness": "Strela fu bistra",
  "item.minecraft.tipped_arrow.effect.thick": "Strela mitt taikashtof",
  "item.minecraft.tipped_arrow.effect.turtle_master": "Strela fu grenzajewalt",
  "item.minecraft.tipped_arrow.effect.water": "Strela fu ishkejit",
  "item.minecraft.tipped_arrow.effect.water_breathing": "Strela fu ishkehengideki",
  "item.minecraft.tipped_arrow.effect.weakness": "Strela fu shvants",
  "item.minecraft.tipped_arrow.effect.weaving": "Strela fu raznuito",
  "item.minecraft.tipped_arrow.effect.wind_charged": "Strela fu luftpulap",
  "item.minecraft.tnt_minecart": "Rofainen mit bambam",
  "item.minecraft.torchflower_seeds": "Kirkasblume pie",
  "item.minecraft.totem_of_undying": "Ervona boneka",
  "item.minecraft.trader_llama_spawn_egg": "Sintuajaitso f'Hoklama",
  "item.minecraft.trial_key": "Iskatklucj",
  "item.minecraft.trident": "Sardeshkadai",
  "item.minecraft.tropical_fish": "Sakana fu veltkraisdai",
  "item.minecraft.tropical_fish_bucket": "Badzhel fu sakana fu mellanveltkrais",
  "item.minecraft.tropical_fish_spawn_egg": "Sintuajaitso f'Sakana fu mellanveltkrais",
  "item.minecraft.turtle_helmet": "Breshkakomuske",
  "item.minecraft.turtle_scute": "Komuskepone fu breshka",
  "item.minecraft.turtle_spawn_egg": "Sintuajaitso f'Breshka",
  "item.minecraft.vex_armor_trim_smithing_template": "Jerkatbaksu",
  "item.minecraft.vex_armor_trim_smithing_template.new": "Rovo komuskefal",
  "item.minecraft.vex_spawn_egg": "Sintuajaitso f'Rovodjin",
  "item.minecraft.villager_spawn_egg": "Sintuajaitso f'Statdjin",
  "item.minecraft.vindicator_spawn_egg": "Sintuajaitso f'Warusadadjin",
  "item.minecraft.wandering_trader_spawn_egg": "Sintuajaitso f'Razskei hokdjin",
  "item.minecraft.ward_armor_trim_smithing_template": "Jerkatbaksu",
  "item.minecraft.ward_armor_trim_smithing_template.new": "Eshku komuskefal",
  "item.minecraft.warden_spawn_egg": "Sintuajaitso f'Erdarmdjin",
  "item.minecraft.warped_fungus_on_a_stick": "Erstranitari na vjetka",
  "item.minecraft.water_bucket": "Ishkeklingedai",
  "item.minecraft.wayfinder_armor_trim_smithing_template": "Jerkatbaksu",
  "item.minecraft.wayfinder_armor_trim_smithing_template.new": "Strelating komuskefal",
  "item.minecraft.wheat": "Panmun",
  "item.minecraft.wheat_seeds": "Panpie",
  "item.minecraft.white_bundle": "Shiro festakaban",
  "item.minecraft.white_dye": "Shiro faria",
  "item.minecraft.white_harness": "Shiro sparatang",
  "item.minecraft.wild_armor_trim_smithing_template": "Jerkatbaksu",
  "item.minecraft.wild_armor_trim_smithing_template.new": "Dasos komuskefal",
  "item.minecraft.wind_charge": "Luftbamba",
  "item.minecraft.witch_spawn_egg": "Sintuajaitso f'Taikadjin",
  "item.minecraft.wither_skeleton_spawn_egg": "Sintuajaitso f'Witherponedjin",
  "item.minecraft.wither_spawn_egg": "Sintuajaitso f'Wither",
  "item.minecraft.wolf_armor": "Eshkuklea fu lupo",
  "item.minecraft.wolf_spawn_egg": "Sintuajaitso f'Lupo",
  "item.minecraft.wooden_axe": "Baum jondu",
  "item.minecraft.wooden_hoe": "Baum piegørmoi",
  "item.minecraft.wooden_pickaxe": "Baum puangørmoi",
  "item.minecraft.wooden_shovel": "Baum qoilara",
  "item.minecraft.wooden_spear": "Baum streladai",
  "item.minecraft.wooden_sword": "Baum herus",
  "item.minecraft.writable_book": "Libre mit pjera",
  "item.minecraft.written_book": "Kakena libre",
  "item.minecraft.yellow_bundle": "Kiro festakaban",
  "item.minecraft.yellow_dye": "Kiiro faria",
  "item.minecraft.yellow_harness": "Kiiro sparatang",
  "item.minecraft.zoglin_spawn_egg": "Sintuajaitso f'Zoglin",
  "item.minecraft.zombie_horse_spawn_egg": "Sintuajaitso f'Odaremhengest",
  "item.minecraft.zombie_nautilus_spawn_egg": "Sintuajaitso f'Odarembeihjen",
  "item.minecraft.zombie_spawn_egg": "Sintuajaitso f'Odarem",
  "item.minecraft.zombie_villager_spawn_egg": "Sintuajaitso f'Odaremstatdjin",
  "item.minecraft.zombified_piglin_spawn_egg": "Sintuajaitso f'Odarempiglin"
}
export const vp_vl = items; 
